
<script>
import Vue from 'vue'
import MiChess from 'chess.js'
// import Chessground from 'chessground'
// import tooltip from 'vue-material-components'
import toast from 'vue-material-components'
import Store from '../../services/lstorage'
import UploadFilesLesson from './uploadFiles'
import config from '../../../server/config.js'
import ClubService from '../../services/club'
import openai from '../../services/openaiutils'
import BoardVisorIa from '../game/boardVisorIa'
import EngineGame from '../../services/enginegame.js'
// import Jquery from 'jquery'
// import audio from '../../services/audio'
// const synth = window.speechSynthesis
// let mediaRecorder
// const audioChunks = []
// Gestiona el audio
/* const handleSuccess = (stream) => {
  mediaRecorder = new MediaRecorder(stream)
  mediaRecorder.addEventListener('dataavailable', (event) => {
    audioChunks.push(event.data)
    // Crear objeto FormData y agregar audio Blob
    const audioBlob = new Blob(audioChunks, { type: 'audio/wav' })
    const formData = new FormData()
    formData.append('audio', audioBlob, 'audio.wav')
    // Enviar FormData a Node.js
    fetch('/uploads/audio', {
      method: 'POST', body: formData
    })
    .then((response) => {
      console.log('response.status ', response.status)
      // window.alert(response.status)
      // socket.emit('obtener-transcripcion');
    })
    .catch((error) => {
      console.error('Error: ', error)
    })
  })
}
// Captura el audio grabado del micro
navigator.mediaDevices.getUserMedia({ audio: true }).then(handleSuccess)*/
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
var playEvent = 1
export default {
  name: 'BoardHistory',
  props: {
    history: {
      type: Array
    },
    pgn: {
      type: String
    },
    fen: {
      type: String
    },
    user: {
    },
    only: {
      type: Boolean,
      required: false,
      'default': false
    },
    events: {
      type: Boolean,
      required: false,
      'default': false
    },
    sendtoteacher: {
      type: Boolean,
      required: false,
      'default': false
    },
    userchat: {
      type: String
    },
    boardid: {
      type: String,
      required: false
    },
    board: {
      type: Object,
      'default': null
    },
    active: {
      type: Boolean,
      required: false,
      'default': false
    },
    humanvspc: {
      type: Function,
      required: false,
      'default': function () {
        return false
      }
    }
  },
  computed: {
    validBoard () {
      return Array.isArray(this.board) ? null : this.board
    },
    isParamOnly () {
      // Asegurarse de que $route y $route.params existen antes de acceder
      return this.only
    }
  },
  data () {
    return {
      speech: null, // Almacenar el objeto SpeechSynthesisUtterance
      velo: 2,
      select: -1,
      played: false,
      intervalMouth: null,
      iframe: {
        src: window.location.href,
        style: null,
        wrapperStyle: null
      },
      eval: 0,
      stockfish: {},
      styleboard: true,
      stylesBoard: stylesBoard,
      classBoard: '',
      boardView: Store.get('boardView', {}),
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      chess: new MiChess(),
      dirActionUpload: Store.get('serverDir') + '/chat/upload',
      dirActionUploadAudio: Store.get('serverDir') + '/chat/uploadaaudio',
      value: [],
      dirServer: Store.get('serverDir'),
      fileProgress: 0,
      filesUploadHistory: [],
      urlLinkUpload: '',
      allFilesUploaded: true,
      visibleHistory: false,
      strNameResource: '',
      enroqueK: true,
      enroqueQ: true,
      enroqueq: true,
      enroquek: true,
      chkLesson: false,
      typeLesson: '',
      nameLesson: '',
      nameCategory: '',
      nameAnalysis: '',
      listaclubs: [],
      listaVoces: [],
      myVoiceSelected: Store.get('selectedVoice'),
      listaVocesSelected: Store.get('selectedVoice'),
      clubActual: '',
      clubActual1: '',
      clubActual2: '',
      clubs: '',
      recording: false,
      airesponse: '',
      aiquestion: '',
      timeLeft: 0,
      mediaRecorder: null,
      audioChunks: [],
      audioStream: null,
      varTextToSpeach: true
    }
  },
  components: {
    UploadFilesLesson,
    BoardVisorIa
  },
  mixins: [
    // tooltip
    toast
  ],
  events: {
    onFileClick (file) {
      // console.log('onFileClick', file)
    },
    onFileChange (file) {
      // console.log('onFileChange', file)
      // here is where we update our view
      this.fileProgress = 0
      this.allFilesUploaded = false
    },
    beforeFileUpload (file) {
      // called when the upload handler is called
      // console.log('beforeFileUpload', file)
      this.toast('<span>' + 'Cargando archivo' + '</span>', 2000)
    },
    afterFileUpload (file) {
      // called after the xhr.send() at the end of the upload handler
      // console.log('afterFileUpload', file)
      this.toast('<span>' + Vue.t('home.uploadMens.success') + file.name + '</span>', 2000)
      // window.alert(this.dirServer + '/uploads/' + file.name)
    },
    onFileProgress (progress) {
      // console.log('onFileProgress', progress)
      // update our progress bar
      this.fileProgress = parseInt(progress.percent)
    },
    hasResource () {
      var ret = false
      var idFEN = document.getElementById('myFENValue')
      if (this.board.urls !== undefined && this.board.urls.length > 0) {
        var iFound = this.board.urls.indexOf(idFEN.value)
        if (iFound >= 0) {
          ret = true
        }
      }
      return ret
    },
    onFileUpload (file, res) {
      console.log('onFileUpload', file, res)
      if (this.strNameResource.length <= 0) {
        // window.alert('Debe rellenar un nombre para el recurso')
        window.swal('Debe rellenar un nombre para el recurso', {
          buttons: {
            si: {text: 'Aceptar', value: 'accept'}
          }
        }).then(function (resultParam) {
        })
        return
      }
      /* this.chattext = {
        name: file.name,
        size: file.size,
        type: file.type,
        lastModifiedDate: file.lastModifiedDate
      } */
      // window.alert('Subido: ' + this.dirServer + '/uploads/' + JSON.stringify(file))
      var idFEN = document.getElementById('myFENValue')
      var last = ''
      // this.board.urls = 'rnbqkbnr/pp2pppp/2p5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - 0 3={amador=https://www.youtube.com/embed/NpSNXVZVmg8}{link=https://www.microsoft.com}{pdf=http://www.africau.edu/images/default/sample.pdf}{imagen=https://upload.wikimedia.org/wikipedia/commons/4/47/PNG_transparency_demonstration_1.png};'
      // window.alert(this.board.urls)
      if (this.board.urls !== undefined && this.board.urls.length > 0) {
        // window.alert(this.board.urls)
        var iFound = this.board.urls.indexOf(idFEN.value)
        if (iFound >= 0) {
          // window.alert(idFEN.value)
          var nInitUrls = iFound + idFEN.value.length + 1
          var nFinUrls = this.board.urls.indexOf(';', nInitUrls)
          last = this.board.urls.substring(nInitUrls, nFinUrls)
          let nn = '{' + this.strNameResource + '=' + this.dirServer + '/uploads/' + file.name + '}'
          let nuevo = last + nn
          // window.alert(last + '->' + nuevo)
          this.board.urls = this.board.urls.replace(last, nuevo)
        }
      }
      if (last.length <= 0) {
        this.board.urls += idFEN.value + '={' + this.strNameResource + '=' + this.dirServer + '/uploads/' + file.name + '};'
        this.strNameResource = ''
        // idFEN.value = idFEN.value
        // idFEN.textContent = idFEN.value
        // idFEN.dispatchEvent(new window.Event('input'))
        // window.alert(txtPgn)
        // this.$broadcast('modal::close', 'some', 'setResource')
      }

      if (document.querySelector('#pgnComment' + ' textarea.comment')) {
        var oldVal = document.querySelector('#pgnComment' + ' textarea.comment').value
        // window.alert(oldVal)
        document.querySelector('#pgnComment' + ' textarea.comment').value = oldVal + ' ' + 'RECURSO'
        document.querySelector('#pgnComment' + ' textarea.comment').dispatchEvent(new window.Event('change'))
      }
      // window.alert(JSON.stringify(this.board))
      // this.sendMensaje('file')
    },
    onFileError (file, res) {
      this.toast('<span>Error ' + res + '</span>', 3000)
      // console.error('onFileError', file, res)
    },
    onAllFilesUploaded (files) {
      // console.log('onAllFilesUploaded', files)
      this.toast('<span>' + Vue.t('home.uploadMens.success') + '</span>', 2000)
      // everything is done!
      this.allFilesUploaded = true
      this.$broadcast('modal::close', 'some', 'setResource')
      // this.setDataPosition()
    }
    /* mensendactivate (data) {
      // -- Cambiar un permiso
      // UserService.setUser(this.user)
      /* if (data.men.user.nickname === this.user.username) {
        this.user.sendtoanalyse = data.men.user.sendtoanalyse
        // window.alert(data.men.user.nickname.sendtoanalyse)
      }*
      if (data.men.user.username === this.user.username) {
        this.user.sendtoanalyse = data.men.user.sendtoanalyse
      }
      // --
      // }
    }*/
  },
  methods: {
    setTextToSpeach () {
      // window.alert('setTextToSpeach')
      this.varTextToSpeach = !this.varTextToSpeach
      if (this.varTextToSpeach === false) {
        clearInterval(this.intervalMouth)
        this.getMouthShape('a') // Resetear la forma de la boca al final
        window.speechSynthesis.cancel()
      }
    },
    scrollBottom () {
      const chatContent = document.getElementById('chat-content')
      if (chatContent) {
        // Scroll suavemente al final usando scrollTo y el método behavior 'smooth'.
        chatContent.scrollTo({
          top: chatContent.scrollHeight,
          behavior: 'smooth'
        })
      }
    },
    countdown () {
      // document.getElementById('seconds').innerHTML = String(this.timeLeft)
      this.timeLeft--
      if (this.timeLeft > 0) {
        setTimeout(this.countdown, 1000)
      } else {
        this.timeLeft = 0
        this.mediaRecorder.stop()
        // this.$broadcast('modal::close', 'some', 'countDownModalCenter')
        // $('#countDownModalCenter').modal('hide')
        // $('#btnStart').disabled = false
      }
    },
    hasComments () {
      if (document.getElementById('pgnComment')) {
        return true
      }
      // window.alert('has')
      return false
    },
    answerIA (message) {
      var convertido = message.split('\n').join('<br>')
      let item = `<div class="media media-chat" data-toggle="modal" data-target="#assistantModalCenter">
                      <div class="media-body">
                          <p>${convertido}</p>
                      </div>
                  </div>`
      return item
    },
    answerUser (message) {
      let item = `<div class="media media-chat media-chat-reverse">
                    <div class="media-body">
                        <p>${message}</p>
                    </div>
                </div>`
      return item
    },
    getMouthShape (phoneme) {
      // Controlar las formas de la boca basadas en el fonema
      if (document.getElementById('mouth1')) {
        document.getElementById('mouth1').style.opacity = '0'
        document.getElementById('mouth2').style.opacity = '0'
        document.getElementById('mouth3').style.opacity = '0'
        document.getElementById('mouth4').style.opacity = '0'
        document.getElementById('tongue').style.opacity = '0'
        document.getElementById('tongue4').style.opacity = '0'

        let mouthId = 'mouth1'
        if (['a', 'e'].includes(phoneme)) mouthId = 'mouth2'
        if (['o', 'u'].includes(phoneme)) mouthId = 'mouth3'
        if (phoneme === 'i') mouthId = 'mouth4'

        document.getElementById(mouthId).style.opacity = '1'

        // Mostrar la lengua si es necesario
        if (mouthId === 'mouth3') document.getElementById('tongue').style.opacity = '1'
        if (mouthId === 'mouth4') document.getElementById('tongue4').style.opacity = '1'
      }
    },
    animateMouth (text) {
      let index = 0
      this.intervalMouth = setInterval(() => {
        if (index >= text.length) {
          clearInterval(this.intervalMouth)
          this.getMouthShape('a') // Resetear a la forma base
          return
        }
        // Cambiar forma según el fonema actual
        const phoneme = text[index].toLowerCase()
        this.getMouthShape(phoneme)
        index++
      }, 120) // Animar la boca cada 200 ms
    },
    moveHead () {
      const botSVG = document.getElementById('botSVG')
      if (botSVG) {
        botSVG.style.transform = 'translateY(-5px)'
        setTimeout(() => {
          botSVG.style.transform = 'translateY(0px)'
        }, 100)
      }
    },
    animateEyes () {
      const leftPupil = document.getElementById('leftPupil')
      if (leftPupil) {
        const rightPupil = document.getElementById('rightPupil')
        // Simular parpadeo al reducir el radio del ojo
        setInterval(() => {
          leftPupil.setAttribute('r', '1')
          rightPupil.setAttribute('r', '1')
          setTimeout(() => {
            leftPupil.setAttribute('r', '3')
            rightPupil.setAttribute('r', '3')
          }, 150)
        }, 3000) // Parpadear cada 3 segundos
      }
    },
    animateEyebrows () {
      const leftEyebrow = document.getElementById('leftEyebrow')
      if (leftEyebrow) {
        const rightEyebrow = document.getElementById('rightEyebrow')
        // Animar cejas al levantar y bajar
        setInterval(() => {
          leftEyebrow.setAttribute('y', '65')
          rightEyebrow.setAttribute('y', '65')
          setTimeout(() => {
            leftEyebrow.setAttribute('y', '60')
            rightEyebrow.setAttribute('y', '60')
          }, 300)
        }, 2000) // Mover cejas cada 4 segundos
      }
    },
    startSpeakingAnimation (text) {
      this.moveHead()
      this.animateMouth(text)
      this.animateEyes()
      this.animateEyebrows()
    },
    textToSpeach (text) {
      if (this.isParamOnly === false || true) {
        clearInterval(this.intervalMouth)
        this.getMouthShape('a') // Resetear la forma de la boca al final
        window.speechSynthesis.cancel()
        this.speech = new SpeechSynthesisUtterance(text)
        const voices = window.speechSynthesis.getVoices()
        for (let i = 0; i < voices.length; i++) {
          if (voices[i].name === this.listaVocesSelected) {
            this.speech.voice = voices[i]
            break
          }
          // window.alert(voices[i].name)
        }
        // Vincular eventos onstart y onend a la instancia de speech
        this.speech.onstart = () => {
          this.moveHead() // Mover la cabeza al iniciar
          this.animateMouth(text) // Iniciar animación de la boca
          this.animateEyes() // Iniciar movimiento de ojos
          this.animateEyebrows() // Iniciar movimiento de cejas
        }
        this.speech.onend = () => {
          // window.alert('onend')
          clearInterval(this.intervalMouth)
          this.getMouthShape('a') // Resetear la forma de la boca al final
        }
          // this.listaVocesFill = this.listaVoces.length
        // const selectedOption =
          // voiceSelect.selectedOptions[0].getAttribute("data-name");
        /* for (let i = 0; i < voices.length; i++) {
          this.listaVoces.push(voices[i])
        }*/
          /* if (voices[i].name === selectedOption) {
            utterThis.voice = voices[i];
            break;
          }*/
        // }
        // utterThis.pitch = pitch.value
        // utterThis.rate = rate.value
        if (this.varTextToSpeach === true) {
          // this.startSpeakingAnimation(text)
          window.speechSynthesis.speak(this.speech)
        }
      }
    },
    cleanPGNContent (str) {
      return str.replace(/(\r?\n){2,}/g, '\n\n') // Mantener exactamente dos saltos entre partidas
        .replace(/\r?\n/g, (match, offset, string) => {
          const prevChar = string[offset - 1]
          const nextChar = string[offset + 1]
          // Si está entre partidas (dos saltos consecutivos), mantener el salto
          if (prevChar === '\n') {
            return match // No modificar, es parte de la separación entre partidas
          }
          // Si está dentro de los movimientos o comentarios
          if (prevChar === ']' || nextChar === '[') {
            return match // Mantener el salto de línea
          }
          return ' ' // Reemplazar con un espacio
        }).replace(/ {2,}/g, ' ') // Eliminar espacios dobles
    },
    prettyPgn (strParam) {
      // str = str.replace(/\u2605/g, '').replace(/\u0445/g, 'x')
      // str = ' ' + str.replace(/\./g, ' ').replace(/(\[FEN [^\]]+\])+?/g, function ($0, $1) { return $1.replace(/\[|\]|"/g, '').replace(/\s/g, '.') })
      // str = str.replace(/\[Event /g, '* [Event ').replace(/\s(\[[^\]]+\])+?/g, '').replace(/(\{[^\}]+\})+?/g, '')
      /* var r = /(\([^\(\)]+\))+?/g
      while (r.test(str)) {
        str = str.replace(r, '')
      }*/
      // window.alert(str)
      // str = decodeURIComponent((str))
      var str = strParam
      try {
        // Intentar decodificar la cadena como UTF-8
        str = decodeURIComponent(escape(strParam))
      } catch (e) {
        str = strParam
      }
      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O') // .replace(/(1\-0|0\-1|1\/2\-1\/2)/g, ' * ').replace(/\s\d+/g, ' ').replace(/\$\d+/g, '').replace(/\?/g, '')
      str = this.cleanPGNContent(str)
      return str
    },
    generateQuestion (textArg, pgn) {
      try {
        var conversation = ''
        const chatContent = document.getElementById('chat-content')
        if (chatContent) {
          conversation = chatContent.innerText
        }
        if (chatContent) {
          chatContent.innerHTML += this.answerUser(textArg)
          this.scrollBottom()
        }
        openai.generateQuestion(textArg, pgn, conversation).then(data => {
          console.log('Datos recibidos: ', data)
          const aiResponse = data.choices[0].message.content

          // Buscar el contenido entre <<< y >>>, incluyendo saltos de línea y espacios
          const match = aiResponse.match(/<<<([\s\S]*?)>>>/)
          if (match && match[1]) {
            this.pgn = match[1].trim()
            var prettyPgn = this.prettyPgn(this.translatePieceCodesInComments(match[1].trim()))
            this.$broadcast('updatePgnIA', prettyPgn)
          }

          // Convertir sólo los movimientos en el texto que están fuera de <<<>>>
          let speechContent = aiResponse
          if (match && match[1]) {
            speechContent = aiResponse.replace(match[1].trim(), '')
          }
          speechContent = this.convertMovesToSpeechOutsideMarkers(speechContent)
          if (chatContent) {
            chatContent.innerHTML += this.answerIA(aiResponse)
            this.scrollBottom()
          }
          this.textToSpeach(speechContent)
          this.habilitarBotones()
        }).catch(error => {
          console.error('Error al generar texto: ', error)
          window.swal(`Error: ${error.message}`)
          this.habilitarBotones()
        })
      } catch (error) {
        console.error(`Error: ${error.message}`)
        window.swal(`Error: ${error.message}`)
        this.habilitarBotones()
      }
    },

    // Nueva función para convertir movimientos en notación PGN fuera de <<<>>>
    convertMovesToSpeechOutsideMarkers (text) {
      // Dividir el texto en segmentos fuera y dentro de <<<>>>
      const segments = []
      let lastIndex = 0

      // Expresión regular para encontrar bloques <<<>>>
      const markerRegex = /<<<[\s\S]*?>>>/g
      let match

      while ((match = markerRegex.exec(text)) !== null) {
        // Texto antes del marcador
        if (match.index > lastIndex) {
          segments.push({
            text: text.substring(lastIndex, match.index),
            isInsideMarkers: false
          })
        }
        // Texto dentro del marcador
        segments.push({
          text: match[0],
          isInsideMarkers: true
        })
        lastIndex = match.index + match[0].length
      }

      // Texto después del último marcador
      if (lastIndex < text.length) {
        segments.push({
          text: text.substring(lastIndex),
          isInsideMarkers: false
        })
      }

      // Procesar segmentos
      const processedText = segments.map(segment => {
        if (segment.isInsideMarkers) {
          // Dejar el texto dentro de <<<>>> sin cambios
          return segment.text
        } else {
          // Convertir movimientos en el texto fuera de <<<>>>
          return this.convertMovesToSpeech(segment.text)
        }
      }).join('')

      return processedText
    },

    // Función existente para convertir movimientos en notación PGN dentro de un texto
    convertMovesToSpeech (text) {
      // Expresión regular para encontrar movimientos en notación PGN
      const moveRegex = /\b([KQRBNDTAC]?[a-h]?[1-8]?x?[a-h][1-8](=[QRBNDTAC])?[+#]?|O-O(-O)?)(?=\b|[^a-zA-Z0-9])/g

      const pieceNames = {
        K: 'Rey',
        Q: 'Dama',
        R: 'Torre',
        B: 'Alfil',
        N: 'Caballo'
      }

      const pieceNamesSpanish = {
        R: 'Rey',
        D: 'Dama',
        T: 'Torre',
        A: 'Alfil',
        C: 'Caballo'
      }

      const files = { a: 'a', b: 'b', c: 'c', d: 'd', e: 'e', f: 'f', g: 'g', h: 'h' }
      const ranks = { '1': 'uno', '2': 'dos', '3': 'tres', '4': 'cuatro', '5': 'cinco', '6': 'seis', '7': 'siete', '8': 'ocho' }

      // Reemplazar cada movimiento encontrado por su descripción verbal
      const convertedText = text.replace(moveRegex, (move) => {
        let verbalMove = ''

        if (move === 'O-O') {
          verbalMove = 'enroque corto'
        } else if (move === 'O-O-O') {
          verbalMove = 'enroque largo'
        } else {
          let capture = move.includes('x')
          let promotion = move.includes('=')
          let check = move.includes('+')
          let checkmate = move.includes('#')

          // Remover anotaciones de jaque y mate
          move = move.replace(/[+#]/g, '')

          // Manejar promociones
          let promotionPiece = ''
          if (promotion) {
            const parts = move.split('=')
            move = parts[0]
            promotionPiece = parts[1]
          }

          // Identificar pieza (por defecto es peón si no se especifica)
          let piece = ''
          // window.alert(piece)
          if (/[KQRBN]/.test(move[0])) {
            piece = pieceNames[move[0]]
            move = move.slice(1)
          }
          if (/[RDTAC]/.test(move[0])) {
            piece = pieceNamesSpanish[move[0]]
            move = move.slice(1)
          }

          // Manejar especificaciones de origen
          let from = ''
          if (move.length > 2 && !move.startsWith('x')) {
            if (files[move[0]] || ranks[move[0]]) {
              from = move[0]
              move = move.slice(1)
            }
          }

          // Manejar capturas
          if (capture) {
            const parts = move.split('x')
            if (parts[0]) {
              from = parts[0]
            }
            move = parts[1]
          }

          // Obtener destino
          const toFile = files[move[0]]
          const toRank = ranks[move[1]]

          // Construir la descripción verbal
          if (capture) {
            if (from) {
              verbalMove = `${piece} desde ${from} captura en ${toFile} ${toRank}`
            } else {
              verbalMove = `${piece} captura en ${toFile} ${toRank}`
            }
          } else {
            if (from) {
              verbalMove = `${piece} desde ${from} a ${toFile} ${toRank}`
            } else {
              if (piece.length <= 0) {
                verbalMove = `${toFile} ${toRank}`
              } else {
                verbalMove = `${piece} a ${toFile} ${toRank}`
              }
            }
          }

          // Agregar promoción si existe
          if (promotionPiece) {
            verbalMove += ` y se promociona a ${pieceNames[promotionPiece]}`
          }

          // Agregar jaque o mate si aplica
          if (check) {
            verbalMove += ', jaque'
          } else if (checkmate) {
            verbalMove += ', jaque mate'
          }
        }

        return verbalMove
      })

      return convertedText
    },
    handleSuccess (stream) {
      this.audioStream = stream
      this.mediaRecorder = new MediaRecorder(stream)
      this.mediaRecorder.addEventListener('dataavailable', this.onDataAvailable)
      this.mediaRecorder.start()
    },
    startRecording () {
      if (this.timeLeft === 0) {
        this.timeLeft = 10
        // $('#btnStart').disabled = true
        if (this.timeLeft > 0) {
          // this.$broadcast('modal::open', 'countDownModalCenter')
          // $('#countDownModalCenter').modal('show')
          setTimeout(this.countdown, 1000)
        }
        this.audioChunks.length = 0
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then(this.handleSuccess)
          .catch((error) => console.error('Error al obtener el stream:', error))
        // mediaRecorder.start()
      } else {
        this.stopRecording()
      }
    },
    stopRecording () {
      this.timeLeft = 0
      if (this.mediaRecorder) {
        this.mediaRecorder.stop()
      }
      if (this.audioStream) {
        this.audioStream.getTracks().forEach(track => track.stop())  // Detener el stream de audio
      }
      // $('#btnStart').disabled = false
    },
    onDataAvailable (event) {
      this.audioChunks.push(event.data)
      if (this.mediaRecorder.state === 'inactive') {
        this.sendAudio()
      }
    },
    _handleUpload (file) {
      // this.$dispatch('beforeFileUpload', file)
      var form = new window.FormData()
      var xhr = new window.XMLHttpRequest()
      try {
        form.append('Content-Type', file.type || 'audio/wav')
        // our request will have the file in the ['file'] key
        form.append('file', file)
      } catch (err) {
        // this.$dispatch('onFileError', file, err)
        return
      }
      return new Promise(function (resolve, reject) {
        xhr.upload.addEventListener('progress', this._onProgress, false)
        xhr.onreadystatechange = function () {
          if (xhr.readyState < 4) {
            return
          }
          if (xhr.status < 400) {
            var res = xhr.responseText
            var newFile = {
              name: file.name,
              size: file.size,
              type: file.type,
              lastModifiedDate: file.lastModifiedDate,
              path: res.filePath
            }
            // this.value.push(newFile)
            // this.$dispatch('onFileUpload', newFile, res)
            console.log('Ruta del archivo:', res.filePath)
            resolve(newFile)
          } else {
            var err = xhr.responseText
            // this.$dispatch('onFileError', file, err)
            reject(err)
          }
        }
        xhr.onerror = function () {
          var err = JSON.parse(xhr.responseText)
          this.$dispatch('onFileError', file, err)
          reject(err)
        }.bind(this)
        const filename = 'audio.wav'
        xhr.open(this.method || 'POST', `${this.dirActionUploadAudio}?filename=${filename}`, true)
        if (this.headers) {
          for (var header in this.headers) {
            xhr.setRequestHeader(header, this.headers[header])
          }
        }
        xhr.send(form)
        this.$dispatch('afterFileUpload', file)
      }.bind(this))
    },
    blobToFile (theBlob, fileName) {
      // A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    transcribeAudio (file) {
      try {
        openai.transcribeAudio(file).then(data => {
          console.log('Datos recibidos: ', data)
          // this.airesponse = data
          // const chatContent = document.getElementById('chat-content')
          this.preguntaAI(data)
          /* if (chatContent) {
            chatContent.innerHTML += this.answerUser(data)
            this.scrollBottom()
          }
          if (chatContent) {
            chatContent.innerHTML += this.answerIA(this.airesponse)
            this.scrollBottom()
          }*/
          this.habilitarBotones()
          // Aquí manejas los datos recibidos
        }).catch(error => {
          console.error('Error al generar texto: ', error)
          this.habilitarBotones()
          // Maneja el error aquí
        })
      } catch (error) {
        console.error(`Error: ${error.message}`)
      }
    },
    sendAudio () {
      const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })
      var audioFile = this.blobToFile(audioBlob, 'audio.wav')
      // window.alert(JSON.stringify(audioFile))
      this._handleUpload(audioFile)
      setTimeout(function () {
        this.transcribeAudio(audioFile)
        .then(transcription => {
          console.log('Transcripción:', transcription)
        })
        .catch(error => {
          console.error('Error al transcribir audio:', error)
        })
      }.bind(this), 1000)
    },
    generateText (textArg) {
      try {
        // window.swal(textArg)
        openai.generateText(textArg, this.pgn).then(data => {
          console.log('Datos recibidos: ', data)
          let textoLimpio = data.choices[0].message.content.replace(/[\n\r\t]/g, ' ')
          textoLimpio = this.translatePieceCodesInComments(textoLimpio)
          // window.alert(JSON.stringify(data.choices[0].message.content))
          const speechContent = this.convertMovesToSpeechOutsideMarkers(textoLimpio)
          this.textToSpeach(speechContent)
          this.airesponse = textoLimpio
          const chatContent = document.getElementById('chat-content')
          if (chatContent) {
            chatContent.innerHTML += this.answerUser(textArg)
            this.scrollBottom()
          }
          if (chatContent) {
            chatContent.innerHTML += this.answerIA(this.airesponse)
            this.scrollBottom()
          }
          this.habilitarBotones()
          // Aquí manejas los datos recibidos
        }).catch(error => {
          console.error('Error al generar texto: ', error)
          this.habilitarBotones()
          // Maneja el error aquí
        })
      } catch (error) {
        console.error(`Error: ${error.message}`)
      }
    },
    isValidPgn (text) {
      const pgnRegex = /(\[Event\s".*?"\]\s*\[Site\s".*?"\]\s*\[Date\s".*?"\]\s*\[Round\s".*?"\]\s*\[White\s".*?"\]\s*\[Black\s".*?"\]\s*\[Result\s"(1-0|0-1|1\/2-1\/2|\*)"\]([\s\S]*?\[.*? ".*?"\])*)\s*((\d+\.\s*(?:[a-h][1-8]|[KQRBN][a-h1-8]|[KQRBN]x[a-h1-8]|O-O|O-O-O)(?:\s*[+#=Q=R=B=N])?(?:\s*\{[^}]*\})?\s*(?:\d+\.\.\.\s*(?:[a-h][1-8]|[KQRBN][a-h1-8]|[KQRBN]x[a-h1-8]|O-O|O-O-O)(?:\s*[+#=Q=R=B=N])?(?:\s*\{[^}]*\})?)?)*\s*(\*|1-0|0-1|1\/2-1\/2)?)?/
      return pgnRegex.test(text)
    },
    translatePieceCodesInComments (pgnText) {
      // Mapa de traducción para las piezas de ajedrez
      const translationMap = {
        K: 'R', // King -> Rey
        Q: 'D', // Queen -> Dama
        R: 'T', // Rook -> Torre
        B: 'A', // Bishop -> Alfil
        N: 'C'  // Knight -> Caballo
      }
      // Expresión regular para encontrar comentarios en {}
      const commentRegex = /(\{[^}]*\})|(;[^\n]*)/g
      // Función para traducir los códigos de piezas dentro de un comentario
      function translateCodesInComment (comment) {
        return comment.replace(/\b([KQRBN])x?([a-h][1-8])\b/g, (match, p1, p2) => {
          // Reemplaza la letra de la pieza, pero deja las coordenadas de la jugada intactas
          return translationMap[p1] + (match.includes('x') ? 'x' : '') + p2
        })
      }
      // Reemplazar los comentarios con la traducción de códigos de piezas
      const translatedText = pgnText.replace(commentRegex, (match) => translateCodesInComment(match))
      return translatedText
    },
    cleanPgnContent (text) {
      // Expresión regular para capturar el contenido PGN desde la primera etiqueta hasta el último movimiento
      const pgnRegex = /(\[Event\s".*?"\](?:.|\n)*?)(\d+\.\s.*)$/
      // Extraer el contenido PGN válido
      const matches = text.match(pgnRegex)
      if (!matches) {
        console.warn('No se encontró contenido PGN válido.')
        return ''
      }
      // matches[1] contiene las etiquetas y matches[2] los movimientos y resultados
      const validTagsAndMoves = matches[0] // Se toma toda la coincidencia válida
      return validTagsAndMoves.trim()
    },
    generatePGN (textArg) {
      let ret = true
      try {
        let _self = this
        openai.generatePGN(textArg, this.pgn).then(data => {
          console.log('Datos recibidos: ', data)
          let textoLimpio = data.choices[0].message.content.replace(/[\n\r\t]/g, ' ')
          textoLimpio = textoLimpio.replace(/[`]/g, '')
          // window.alert(textoLimpio)
          textoLimpio = _self.cleanPgnContent(textoLimpio)
          // window.alert(textoLimpio)
          // textoLimpio = this.translatePieceCodesInComments(textoLimpio)
          if (_self.isValidPgn(textoLimpio) === false) {
            // window.alert(textoLimpio)
          }
          // window.alert(textoLimpio)
          // this.textToSpeach(data.choices[0].message.content)
          // this.airesponse = data.choices[0].message.content
          if (_self.isValidPgn(textoLimpio)) {
            var idTextArea = document.getElementById('idTextAreaPGN')
            if (idTextArea) {
              // window.alert(textoLimpio)
              // window.alert(data.choices[0].message.content)
              idTextArea.value = textoLimpio
              idTextArea.dispatchEvent(new window.Event('input'))
              idTextArea.dispatchEvent(new window.Event('change'))
              // window.alert(idTextArea.value)
            }
            const chatContent = document.getElementById('chat-content')
            if (chatContent) {
              chatContent.innerHTML += _self.answerUser(textArg)
              this.scrollBottom()
            }
            if (chatContent) {
              chatContent.innerHTML += _self.answerIA(textoLimpio)
              this.scrollBottom()
            }
          } else {
            window.swal('Error en la generación del PGN, vuelva a intentarlo')
            ret = false
          }
          _self.habilitarBotones()
          // Aquí manejas los datos recibidos
        }).catch(error => {
          console.error('Error al generar texto: ', error)
          this.habilitarBotones()
          ret = false
          // Maneja el error aquí
        })
      } catch (error) {
        console.error(`Error: ${error.message}`)
        ret = false
      }
      return ret
    },
    analisisPGN (textArg) {
      try {
        const chatContent = document.getElementById('chat-content')
        if (chatContent) {
          chatContent.innerHTML += this.answerUser(textArg)
          this.scrollBottom()
        }
        openai.analisisPGN(textArg, this.pgn).then(data => {
          console.log('Datos recibidos: ', data)
          const aiResponse = data.choices[0].message.content

          // Buscar el contenido entre <<< y >>>, incluyendo saltos de línea y espacios
          const match = aiResponse.match(/<<<([\s\S]*?)>>>/)
          if (match && match[1]) {
            this.pgn = match[1].trim()
            var prettyPgn = this.prettyPgn(this.translatePieceCodesInComments(match[1].trim()))
            this.$broadcast('updatePgnIA', prettyPgn)
          }

          // Convertir sólo los movimientos en el texto que están fuera de <<<>>>
          let speechContent = aiResponse
          if (match && match[1]) {
            speechContent = aiResponse.replace(match[1].trim(), '')
          }
          speechContent = this.convertMovesToSpeechOutsideMarkers(speechContent)
          if (chatContent) {
            chatContent.innerHTML += this.answerIA(aiResponse)
            this.scrollBottom()
          }
          this.textToSpeach(speechContent)
          this.habilitarBotones()
        }).catch(error => {
          console.error('Error al generar texto: ', error)
          window.swal(`Error: ${error.message}`)
          this.habilitarBotones()
        })
      } catch (error) {
        console.error(`Error: ${error.message}`)
        window.swal(`Error: ${error.message}`)
        this.habilitarBotones()
      }
    },
    habilitarBotones () {
      document.getElementById('overlay').style.display = 'none'
      const chatQuestion = document.getElementById('aiquestion')
      if (chatQuestion) {
        // window.alert(chatQuestion.value)
        chatQuestion.value = ''
      }
    },
    deshabilitarBotones () {
      document.getElementById('overlay').style.display = 'block'
    },
    closeModalIA () {
      if (this.isParamOnly === false || true) {
        window.speechSynthesis.cancel()
        clearInterval(this.intervalMouth)
        this.getMouthShape('a')
      }
      this.$broadcast('modal::close', 'some', 'modalIA')
    },
    getIndexFromFen (fen) {
      const fenParts = fen.split(' ')
      if (fenParts.length !== 6) {
        return -1
      }
      /* const position = fenParts[0]
      const turn = fenParts[1]
      const castling = fenParts[2]
      const enPassant = fenParts[3]
      const halfMoveClock = fenParts[4]*/
      const fullMoveNumber = fenParts[5]
      return fullMoveNumber // Retorna -1 si no se encuentra la posición
    },
    getTurnFromFen (fen) {
      const fenParts = fen.split(' ')
      if (fenParts.length !== 6) {
        return -1
      }
      /* const position = fenParts[0]*/
      const turn = fenParts[1]
      /* const castling = fenParts[2]
      const enPassant = fenParts[3]
      const halfMoveClock = fenParts[4]
      const fullMoveNumber = fenParts[5]*/
      return turn // Retorna -1 si no se encuentra la posición
    },
    showInformationAI () {
      this.deshabilitarBotones()
      // this.airesponse = 'BUSCANDO INFORMACIÓN...'
      this.airesponse = ''
      // this.$broadcast('modal::close', 'some', 'modalCompartir')
      this.generateText(`Comenta esta posición ${this.fen} que pertenece al moviento ${this.getIndexFromFen(this.fen)} de esta partida ${this.pgn}.`)
    },
    esPGNValido (pgn) {
      // window.alert(pgn)
      const etiquetasObligatorias = ['Event', 'Site', 'Date', 'Round', 'White', 'Black', 'Result']
      const etiquetasPresentes = etiquetasObligatorias.every(etiqueta => pgn.includes(`[${etiqueta} `))
      if (!etiquetasPresentes) {
        return false
      }
      const partes = pgn.split('\n\n')
      if (partes.length < 2) {
        return false
      }
      const movimientos = partes[1].trim()
      const regexMovimientos = /^1\.\s*[a-h1-8NBRQKxOo0-9+=#-]+\s*[a-h1-8NBRQKxOo0-9+=#-]+/
      if (!regexMovimientos.test(movimientos)) {
        return false
      }
      const movimientosSeparados = movimientos.split(/\s+[0-9]+\./g).slice(1)
      let secuenciaCorrecta = true
      movimientosSeparados.forEach((movimiento, index) => {
        if (parseInt(movimiento.split('.')[0]) !== index + 2) {
          secuenciaCorrecta = false
        }
      })
      if (!secuenciaCorrecta) {
        return false
      }
      return true
    },
    clone (obj) {
      var dupe = (obj instanceof Array) ? [] : {}
      for (var property in obj) {
        if (typeof property === 'object') {
          dupe[property] = this.clone(obj[property])
        } else {
          dupe[property] = obj[property]
        }
      }
      return dupe
    },
    analizaAI () {
      this.deshabilitarBotones()
      this.analisisPGN(`Analiza la partida en profundiad y dame comentarios en español de los momentos mas críticos de la partida.
        Comentarios sobre la apertura, medio juego y final, tácticas en la partida, estrategia.`)
    },
    commentAI () {
      this.deshabilitarBotones()
      this.generatePGN(`Analiza la partida en profundiad y añade comentarios en español a los principales movimientos de este PGN.
        Comentarios sobre la apertura, medio juego y final, tácticas en la partida, estrategia.
        Devuelve solamente el formato PGN resultante.
        Solo texto dentro del formato PGN
        Comprueba que el PGN sea correcto y que no haya nada mas que el formato PGN ningún otro caracter fuera de ese formato.
        No puedes incluir ningún otro movimiento en el PGN que los que hay, solo comentarios, sin modificar nada mas del PGN`)
    },
    preguntaAI (mensaje = '') {
      this.deshabilitarBotones()
      // this.airesponse = 'BUSCANDO INFORMACIÓN...'
      // this.$broadcast('modal::close', 'some', 'modalCompartir')
      var chatQuestion = document.getElementById('aiquestion')
      var question = ''
      if (chatQuestion) {
        question = chatQuestion.value
      }
      if (mensaje.length > 0) {
        question = mensaje
      }
      // window.alert(question)
      this.generateQuestion(question, this.pgn)
    },
    openChat (video = true) {
      if (config.debug) {
        let handler = window.open(config.video_uri + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      } else {
        let handler = window.open(config.video_uri + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      }
    },
    isVideoSaving () {
      return window.RECORDING_ONGOING
    },
    openVideoSave () {
      window.RECORDING_ONGOING = !window.RECORDING_ONGOING // Start / Stop recording
      if (window.RECORDING_ONGOING) {
        // recordingToggle.innerHTML = "Parar la grabación";
        window.startRecording() // Start the recording
        this.recording = true
      } else {
        // recordingToggle.innerHTML = "Empezar la grabación";
        window.stopRecording() // Stop screen recording
        this.recording = false
      }
    },
    openChatSala (video = true) {
      if (config.debug) {
        let handler = window.open(config.video_uri + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      } else {
        let handler = window.open(config.video_uri + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video)
        handler.blur()
      }
    },
    setLinkUpload () {
      if (this.strNameResource.length <= 0) {
        // window.alert('Debe rellenar un nombre para el recurso')
        window.swal('Debe rellenar un nombre para el recurso', {
          buttons: {
            si: {text: 'Aceptar', value: 'accept'}
          }
        }).then(function (resultParam) {
        })
        return
      }
      // window.alert(this.urlLinkUpload)
      var idFEN = document.getElementById('myFENValue')
      var last = ''
      if (this.board.urls !== undefined && this.board.urls.length > 0) {
        var iFound = this.board.urls.indexOf(idFEN.value)
        if (iFound >= 0) {
          // window.alert(idFEN.value)
          var nInitUrls = iFound + idFEN.value.length + 1
          var nFinUrls = this.board.urls.indexOf(';', nInitUrls)
          last = this.board.urls.substring(nInitUrls, nFinUrls)
          let nn = '{' + this.strNameResource + '=' + this.urlLinkUpload + '}'
          let nuevo = last + nn
          // window.alert(last + '->' + nuevo)
          this.board.urls = this.board.urls.replace(last, nuevo)
        }
      }
      if (last.length <= 0) {
        this.board.urls += idFEN.value + '={' + this.strNameResource + '=' + this.urlLinkUpload + '};'
        idFEN.value = idFEN.value
        idFEN.textContent = idFEN.value
        idFEN.dispatchEvent(new window.Event('input'))
        // window.alert(txtPgn)
        this.$broadcast('modal::close', 'some', 'setResource')
      }
      if (document.querySelector('#pgnComment' + ' textarea.comment')) {
        var oldVal = document.querySelector('#pgnComment' + ' textarea.comment').value
        // window.alert(oldVal)
        document.querySelector('#pgnComment' + ' textarea.comment').value = oldVal + ' ' + 'RECURSO'
        document.querySelector('#pgnComment' + ' textarea.comment').dispatchEvent(new window.Event('change'))
      }
      this.strNameResource = ''
    // (JSON.stringify(this.board))
    },
    listaDeClubs (tipo) {
      var parms = {
        type: tipo
      }
      var _self = this
      _self.listaclubs = []
      ClubService.get(_self, parms).then(function (response) {
        JSON.parse(response).forEach(function (element) {
          _self.listaclubs.push(element)
        })
      }, function (response) {
        this.error = response.data
      })
    },
    isSelected (clubName) {
      var ret = false
      // this.clubs = this.clubs.replace(' ,', ',')
      // this.clubs = this.clubs.replace(', ', ',')
      var clubList = this.clubs.split(',')
      for (var i = 0; i < clubList.length; i++) {
        if (clubName === clubList[i]) {
          // window.alert(clubName)
          ret = true
          break
        }
      }
      return ret
    },
    isSelectedVoice (voice) {
      var ret = false
      if (this.listaVocesSelected === voice.name) {
        ret = true
      }
      return ret
    },
    handleSelectChange (event) {
      // Accede a las opciones seleccionadas
      // const selectedValue = event.target.value
      const selectedValues = Array.from(event.target.selectedOptions).map(option => option.value)
      // const selectedOptions = Jquery('#opciones').val()
      var clubActual = ''
      var count = selectedValues.length
      var num = 0
      selectedValues.forEach(function (element) {
        clubActual += element
        num++
        if (num < count) {
          clubActual += ','
        }
      })
      this.clubActual = clubActual
    },
    /* changeStyle (type) {
      this.styles[type] = this.styles[type] + 1
      if (this.styles[type] > stylesBoard[type].length - 1) {
        this.styles[type] = 0
      }
      this.styleAdapter()
      Store.set('styleBoard', this.styles)
      this.$dispatch('updateBoards', this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']])
    },
    styleAdapter () {
      // window.alert(this.stylesBoard['board'][this.styles['board']])
      * if (this.stylesBoard['board'][this.styles['board']] === 'light-wood-3d') {
        document.getElementById('tablerochess').style.height = (document.getElementById('tablerochess').clientWidth - (document.getElementById('tablerochess').clientWidth * 6.25 / 100)) + 'px'
      } else {
        if (document.getElementById('middle')) {
          var Width = document.getElementById('middle').clientWidth
          document.getElementById('pgnBoard').style.height = Width + 'px'
          document.getElementById('pgnBoard').style.width = Width + 'px'
          document.body.dispatchEvent(new window.Event('chessground.resize'))
        }
        * setTimeout(function () {
          document.getElementById('pgnButtonsfirst').click()
          document.getElementById('pgnButtonslast').click()
        }, 100)*
      }*
      // document.body.dispatchEvent(new window.Event('chessground.resize'))
      // window.location.reload()
    },*/
    isOwner () {
      if (this.board === undefined) {
        this.board = Store.get('boardSee')
      }
      // window.alert(this.user.username + this.board.u1 + this.board.u2)
      return (this.board !== undefined && (this.user.username === this.board.u1 || this.user.username === this.board.u2))
    },
    urlPiece (move) {
      return '/static/images/pieces/cburnett/' + move.color + move.piece.toUpperCase() + '.svg'
    },
    downloadString (text, fileType, fileName) {
      var blob = new window.Blob([text], { type: fileType })
      var a = document.createElement('a')
      a.download = fileName
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = [fileType, a.download, a.href].join(':')
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(function () {
        window.URL.revokeObjectURL(a.href)
      }, 1500)
    },
    sendPermisionToSend () {
      this.$dispatch('sendPermisionToSend', {})
    },
    sendPGNtoTeacher () {
      // window.alert('send')
      this.$dispatch('sendPGNtoTeacher', {})
    },
    analizaPGN () {
      this.$dispatch('analizaPGN', {})
    },
    downloadPGN () {
      // window.alert(this.pgn)
      var pgnChessBase = this.pgn.split('"]').join('"]\n')
      pgnChessBase = pgnChessBase.split('$').join(' $')
      pgnChessBase = pgnChessBase.split('{}').join('')
      // window.alert(pgnChessBase)

      this.downloadString(pgnChessBase, 'text/pgn', 'MiPartida.pgn')
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    parsePgnMoves (pgn) {
      var newlineChar = '\r?\n'
      // var filesObj = {}
      var lines = pgn.split(new RegExp(newlineChar))
      var pgntext = ''
      var state = 0 // 0 header, 1 moves
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].length > 0) {
          // window.alert('Line [' + i + '] ' + lines[i])
          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
            if (state === 1) {
              // filesObj[i] = pgntext
              // pgntext = ''
              // break;
            }
            state = 0
          } else {
            state = 1
          }
          if (state === 0) {
            // pgntext += lines[i] + '\r\n'
          } else {
            pgntext += lines[i] + ' '
          }
        }
      }
      // filesObj[i] = pgntext
      // this.pgnFiles = filesObj
      // this.$broadcast('modal::open', 'pgnFiles')
      return pgntext
    },
    setDataFields () {
      this.board.lessontype = this.typeLesson
      this.board.lesson = this.nameLesson
      this.board.category = this.nameCategory
      this.board.name = this.nameAnalysis
      this.board.club = this.clubActual
      // window.alert(JSON.stringify(this.board))
      this.$broadcast('modal::close', 'some', 'setFields')
    },
    setDataPosition () {
      var pgnInLines = this.pgn.split('"]').join('"]\n')
      pgnInLines = pgnInLines.split('{}').join('')
      var txtPrev = ''
      var headers = this.parse_pgn_header(pgnInLines)
      if (this.fenEvento !== undefined) {
        txtPrev += '[Event "' + this.fenEvento + ' "]\r\n'
      }
      if (this.fenLugar !== undefined) {
        txtPrev += '[Site "' + this.fenLugar + ' "]\r\n'
      }
      if (this.fenFecha !== undefined) {
        txtPrev += '[Date "' + this.fenFecha + ' "]\r\n'
      }
      if (this.fenRonda !== undefined) {
        txtPrev += '[Round "' + this.fenRonda + ' "]\r\n'
      }
      if (this.fenBlancas !== undefined) {
        txtPrev += '[White "' + this.fenBlancas + ' "]\r\n'
      }
      if (this.fenNegras !== undefined) {
        txtPrev += '[Black "' + this.fenNegras + ' "]\r\n'
      }
      if (this.fenResultado !== undefined) {
        txtPrev += '[Result "' + this.fenResultado + ' "]\r\n'
      }
      var idFEN = document.getElementById('myFENValue')
      var txtPgn = ''
      txtPgn = txtPrev
      var idTextArea = document.getElementById('idTextAreaPGN')
      var setup = ''
      var fen = ''
      if (headers['SetUp'] !== undefined) {
        setup = '[SetUp "' + headers['SetUp'] + '"]'
      }
      if (headers['FEN'] !== undefined) {
        fen = '[FEN "' + headers['FEN'] + '"]'
      }
      idTextArea.value = txtPgn + setup + fen + this.parsePgnMoves(pgnInLines)
      idFEN.value = headers['FEN'] !== undefined ? headers['FEN'] : 'start'
      idFEN.textContent = headers['FEN'] !== undefined ? headers['FEN'] : 'start'
      idFEN.dispatchEvent(new window.Event('input'))
      idTextArea.dispatchEvent(new window.Event('change'))
      this.$broadcast('modal::close', 'some', 'setData')
    },
    setFenPosition () {
      if (document.getElementById('iFramePosition')) {
        var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
        var idFEN = document.getElementById('myFENValue')
        var txtPgn = ''
        txtPgn = '[SetUp "1"]\r\n[FEN "' + searchinput.value + '"]'
        var idTextArea = document.getElementById('idTextAreaPGN')
        idTextArea.value = txtPgn
        idFEN.value = searchinput.value
        idFEN.textContent = searchinput.value
        idFEN.dispatchEvent(new window.Event('input'))
        idTextArea.dispatchEvent(new window.Event('change'))
        // window.alert(txtPgn)
      }
      this.$broadcast('modal::close', 'some', 'setFen')
    },
    setFenInit () {
      var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
      searchinput.value = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
      searchinput.dispatchEvent(new window.Event('change'))
      this.enroqueK = true
      this.enroqueQ = true
      this.enroquek = true
      this.enroqueq = true
      // document.getElementById('iFramePosition').contentWindow.dosearch()
    },
    setFenEnroque () {
      var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
      var enroque = (this.enroqueK ? 'K' : '') + (this.enroqueQ ? 'Q' : '') + (this.enroquek ? 'k' : '') + (this.enroqueq ? 'q' : '')
      var fen = searchinput.value.split(' ')
      var fenString = fen[0] + ' ' + fen[1] + ' ' + enroque + ' ' + fen[3] + ' ' + fen[4] + ' ' + fen[5]
      // window.alert(fenString)
      searchinput.value = fenString
      searchinput.dispatchEvent(new window.Event('change'))
      // document.getElementById('iFramePosition').contentWindow.dosearch()
    },
    setFenClear () {
      var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput')
      searchinput.value = '4k3/8/8/8/8/8/8/4K3 b - - 1 2'
      searchinput.dispatchEvent(new window.Event('change'))
      this.enroqueK = false
      this.enroqueQ = false
      this.enroquek = false
      this.enroqueq = false
      // document.getElementById('iFramePosition').contentWindow.dosearch()
    },
    showShare () {
      // this.airesponse = ''
      this.$broadcast('modal::open', 'modalCompartir')
    },
    showIA () {
      // window.alert(JSON.stringify(this.board))
      // this.boardView = this.board
      this.airesponse = ''
      if (this.board._id === undefined) {
        this.board._id = 0
      }
      this.$broadcast('modal::open', 'modalIA')
    },
    playGame () {
      document.getElementById('pgnButtonsfirst').click()
      for (var x = 0; x < 12; x++) {
        if (document.querySelector('#pgnComment' + ' textarea.comment')) {
          var oldVal = document.querySelector('#pgnComment' + ' textarea.comment').value
          const speechContent = this.convertMovesToSpeechOutsideMarkers(oldVal)
          this.textToSpeach(speechContent)
        }
        document.getElementById('pgnButtonsnext').click()
      }
    },
    generateBoardFromFEN (fen) {
      const pieces = {
        'p': '♟', 'r': '♜', 'n': '♞', 'b': '♝', 'q': '♛', 'k': '♚',
        'P': '♙', 'R': '♖', 'N': '♘', 'B': '♗', 'Q': '♕', 'K': '♔'
      }
      // Extraer la parte del tablero del FEN
      const boardFEN = fen.split(' ')[0]
      const rows = boardFEN.split('/')
      let asciiBoard = ''
      rows.forEach((row, rowIndex) => {
        let asciiRow = '|'
        for (const char of row) {
          if (isNaN(char)) {
            // Añadir una pieza
            asciiRow += ` ${pieces[char] || char} |`
          } else {
            // Añadir casillas vacías
            for (let i = 0; i < parseInt(char); i++) {
              asciiRow += '   |'
            }
          }
        }
        asciiBoard += `${asciiRow}\n${'-'.repeat(asciiRow.length)}\n`
      })
      return asciiBoard
    },
    moveToSan (move) {
      // this.chess.load_pgn(this.pgn)
      this.chess.load(this.fen)
      // window.alert(this.fen)
      const moves = this.chess.moves({ verbose: true }) // Obtener movimientos posibles en formato detallado
      // window.alert(JSON.stringify(moves) + move.to + move.from)
      const foundMove = moves.find(m => m.from === move.from && m.to === move.to)
      if (!foundMove) {
        // window.alert('null')
        console.error('foundMove null')
        return null
      }
      const translationMap = {
        K: 'R', // King -> Rey
        Q: 'D', // Queen -> Dama
        R: 'T', // Rook -> Torre
        B: 'A', // Bishop -> Alfil
        N: 'C'  // Knight -> Caballo
      }
      // window.alert(foundMove.san)
      // Función para traducir los códigos de piezas dentro de un comentario
      function translateCodesInComment (comment) {
        return comment.replace(/\b([KQRBN])x?([a-h][1-8])\b/g, (match, p1, p2) => {
          // Reemplaza la letra de la pieza, pero deja las coordenadas de la jugada intactas
          return translationMap[p1] + (match.includes('x') ? 'x' : '') + p2
        })
      }
      var ret = translateCodesInComment(foundMove.san)
      // window.alert(ret)*
      // var ret = foundMove.san
      return ret
    },
    PcIngeniesMoveStockfish (move) {
      // var from = move.from
      // var to = move.to
      // window.alert(from + to)
      // this.onMove(from, to)
      if (this.stockfish !== null && this.stockfish !== undefined) {
        // window.alert('Parando motor de evaluación')
        this.stockfish.close()
        this.stockfish = null
        // const board = this.generateBoardFromFEN(this.fen)
        var turn = this.getTurnFromFen(this.fen) === 'w' ? 'blancas' : 'negras'
        // window.alert(this.fen + ' ' + this.getIndexFromFen(this.fen) + ' ' + ' ' + turn)
        // El FEN es ${this.fen} y su representacion en el tablero es ${board}.
        var text = `Dame un comentario sobre la posición ${this.getIndexFromFen(this.fen)} del pgn que te adjunto.
          Es el turno de las ${turn}.
          Que movimiento recomiendas, revisa las amenazas en el tablero, pero sobretodo la usa como tuya la recomendación que te paso de un motor de ajedrez.
          Tu respuesta no puede ser mayor a 200 caracteres. La notación algebráica que uses tiene que ser siempre en español`
        var san = this.moveToSan(move)
        if (san) {
          text += `la recomendación es ${san}. Sigue las indicaciones de la recomendación y usala como si fuera tuya`
        }
        this.generateText(text)
      }
    },
    insertComments () {
      this.airesponse = ''
      this.deshabilitarBotones()
      // const board = this.generateBoardFromFEN(this.fen)
      var turn = this.getTurnFromFen(this.fen) === 'w' ? 'blancas' : 'negras'
      this.stockfish = EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
      // var baseTime = 1 * 60
      // var inc = 1
      // var level = (parseFloat(this.board.elo) / 100) - 4
      var skill = 20 // 0 600 --> 10 1600 --> 20 --> 2600
      this.stockfish.reset()
      // this.stockfish.setTime(parseFloat(this.time.white), this.time.incremento)
      this.stockfish.setSkillLevel(skill)
      this.stockfish.setDisplayScore(true)
      // this.stockfish.setOwnBook(false)
      this.stockfish.start()
      this.stockfish.setPlayerColor(turn)
      // this.stockfish.setPlayerColor(this.orientation)
      this.stockfish.setTime(parseFloat(30000), 20)
      this.stockfish.setDepth(10)
      this.stockfish.setNodes(0)
      // window.alert(this.pgn)
      this.stockfish.prepareMove(this.fen, '', this.PcIngeniesMoveStockfish, 100000, 100000, 0, 0)
    },
    setResource () {
      this.$broadcast('modal::open', 'setResource')
    },
    updateData () {
      var idPGN = document.getElementById('myPGNValue')
      var idTextArea = document.getElementById('idTextAreaPGN')
      // window.alert(idTextArea)
      // window.alert(idPGN)
      if (idTextArea && idPGN) {
        // window.alert(idPGN.value)
        // idTextArea.value = idPGN.value
        // idTextArea.dispatchEvent(new window.Event('change'))
      }
      setTimeout(() => {
        // window.location.reload()
        var myPGNReload = document.getElementById('myPGNReload')
        if (myPGNReload) {
          // window.alert('myPGNReload')
          myPGNReload.value = 'reload'
          myPGNReload.textContent = 'reload'
          myPGNReload.dispatchEvent(new window.Event('input'))
          myPGNReload.dispatchEvent(new window.Event('change'))
          myPGNReload.blur()
        }
        const idFEN = document.getElementById('myFENValue')
        if (idFEN) {
          document.getElementById('pgnButtonsfirst').click()
          idFEN.value = idFEN.value
          idFEN.textContent = idFEN.value
          idFEN.dispatchEvent(new window.Event('input'))
          idFEN.dispatchEvent(new window.Event('change'))
        }
      }, 500)
    },
    setFen () {
      this.$broadcast('modal::open', 'setFen')
      const checkIframe = setInterval(() => {
        const iframe = document.getElementById('iFramePosition')
        // const setFen = document.getElementById('setFen')
        if (iframe) {
          iframe.style.height = (document.documentElement.scrollHeight) + 'px'
          // window.alert(iframe.style.height)
          clearInterval(checkIframe)
          setTimeout(() => {
            const searchinput = iframe.contentWindow.document.getElementById('fenInputOutput')
            if (searchinput) {
              const idFEN = document.getElementById('myFENValue')
              if (idFEN) {
                searchinput.value = idFEN.value
                searchinput.textContent = idFEN.value
                searchinput.dispatchEvent(new window.Event('input'))
                searchinput.dispatchEvent(new window.Event('change'))
              }
            }
          }, 1000)
        }
      }, 100)
    },
    setFields () {
      this.$broadcast('modal::open', 'setFields')
    },
    setData () {
      var pgnInLines = this.pgn.split('"]').join('"]\n')
      pgnInLines = pgnInLines.split('{}').join('')
      var headers = this.parse_pgn_header(pgnInLines)
      // window.alert(JSON.stringify(headers))
      this.fenEvento = headers['Event'] !== undefined ? headers['Event'] : this.fenEvento
      this.fenLugar = headers['Site'] !== undefined ? headers['Site'] : this.fenLugar
      this.fenFecha = headers['Date'] !== undefined ? headers['Date'] : this.fenFecha
      this.fenRonda = headers['Round'] !== undefined ? headers['Round'] : this.fenRonda
      this.fenBlancas = headers['White'] !== undefined ? headers['White'] : this.fenBlancas
      this.fenNegras = headers['Black'] !== undefined ? headers['Black'] : this.fenNegras
      this.fenResultado = headers['Result'] !== undefined ? headers['Result'] : this.fenResultado
      this.$broadcast('modal::open', 'setData')
    },
    setValues () {
      this.$broadcast('modal::open', 'setValues')
    },
    closeAnalisis () {
      this.$broadcast('modal::close', 'some', 'analisys')
    },
    openModalGraph () {
      // this.openModal()
      this.$broadcast('modal::open', 'analisys')
      setTimeout(function () {
        var searchinput = document.getElementById('iFrameAnalisys').contentWindow.document.getElementById('searchInput')
        // window.alert(window.pgnBoardBase.getPgn().write_pgn())
        if (searchinput) {
          searchinput.value = window.pgnBoardBase.getPgn().write_pgn()
          searchinput.dispatchEvent(new window.Event('change'))
          document.getElementById('iFrameAnalisys').contentWindow.dosearch()
        }
      }, 1000)
    },
    openModalGraphFEN () {
      // this.openModal()
      this.$broadcast('modal::open', 'analisys')
      setTimeout(function () {
        var searchinput = document.getElementById('iFrameAnalisys').contentWindow.document.getElementById('searchInput')
        // window.alert(window.pgnBoardBase.getPgn().write_pgn())
        if (searchinput) {
          var idFEN = document.getElementById('myFENValue')
          searchinput.value = idFEN.value
          searchinput.dispatchEvent(new window.Event('change'))
          document.getElementById('iFrameAnalisys').contentWindow.dosearch()
        }
      }, 1000)
    },
    openModal () {
      // this.$broadcast('modal::open', 'analisisModal')
      if (document.getElementById('analisisModal') && document.getElementById('analisisVertical') && document.getElementById('searchInput')) {
        this.visibleHistory = document.getElementById('analisisModal').style.display
        if (this.visibleHistory === 'none') {
          // document.getElementById('board-history').style = 'display:inline;'
          document.getElementById('analisisModal').style = 'display:inline;z-index:-40;'
          document.getElementById('analisisVertical').style.display = 'inline'
          if (document.getElementById('searchInput') && document.getElementById('myFENValueP')) {
            window.onloadsimplechessboard()
            // document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
            document.getElementById('searchInput').value = document.getElementById('myFENValueP').textContent
            document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
            // window.command(window.pgnBoardBase.getPgn().write_pgn(), document.getElementById('myFENValueP').textContent)
            clearInterval(window.computerGame)
            window.computerGame = setInterval(function () {
              this.showShapes()
            }.bind(this), 1000)
          }
        } else {
          // document.getElementById('board-history').style = 'display:inline;'
          document.getElementById('analisisModal').style = 'display:none;z-index:-40;'
          document.getElementById('analisisVertical').style.display = 'none'
          clearInterval(window.computerGame)
          if (window.ground !== undefined && window.ground !== null) {
            window.ground.setAutoShapes([{
              orig: '-1',
              dest: '-1',
              brush: 'paleGrey',
              modifiers: {lineWidth: 10}
            }, {
              orig: '-1',
              dest: '-1',
              brush: 'paleGrey',
              modifiers: {lineWidth: 4}
            }])
          }
          if (window._engine !== null) {
            // window.alert('terminate')
            window._engine.terminate()
          }
        }
      }
      window.dispatchEvent(new window.Event('resize'))
    },
    showShapes () {
      if (window._curmoves !== undefined && window._curmoves[0] !== undefined) {
        this.eval = window.getEvalText(window._curmoves[0].eval, false)
        var evalfloat = parseFloat(this.eval)
        var value = '0%'
        // window.alert(this.eval)
        if (isNaN(evalfloat) === false) {
          // window.alert(this.eval)
          var eval2 = evalfloat * 10
          // window.alert(eval2)
          var eval25 = 50 + eval2
          eval25 = eval25 < 0 ? 0 : eval25
          // window.alert(eval25)
          // elem.style.width = eval25 + '%'
          if (eval25 < 7) {
            value = '7%'
          } else if (eval25 > 100) {
            value = '95%'
          } else {
            value = eval25 + '%'
          }
        } else {
          if (this.eval.includes('blancas')) {
            value = '100%'
          }
          if (this.eval.includes('negras')) {
            value = '0%'
          }
        }
        var elem = document.getElementById('myBar')
        if (elem) {
          elem.style.marginLeft = value
        }
        elem = document.getElementById('myBar2')
        if (elem) {
          elem.style.height = value
        }
        // console.log(this.eval)
      }
      if (document.getElementById('searchInput') && window._curmoves !== undefined && window._curmoves[0] !== undefined) {
        var sFrom0 = 'abcdefgh'[window._curmoves[0].move.from.x] + '87654321'[window._curmoves[0].move.from.y]
        var sTo0 = 'abcdefgh'[window._curmoves[0].move.to.x] + '87654321'[window._curmoves[0].move.to.y]
        if (window._curmoves[0].answer != null && window._curmoves[0].answer !== undefined) {
          this.eval = window.getEvalText(window._curmoves[0].eval, false)
          var sFrom1 = window._curmoves[0].answer[0] + window._curmoves[0].answer[1]
          var sTo1 = window._curmoves[0].answer[2] + window._curmoves[0].answer[3]
          window.ground.setAutoShapes([{
            orig: sFrom0,
            dest: sTo0,
            brush: 'paleGrey',
            modifiers: {lineWidth: 10}
          }, {
            orig: sFrom1,
            dest: sTo1,
            brush: 'paleGrey',
            modifiers: {lineWidth: 4}
          }])
        } else {
          window.ground.setAutoShapes([{
            orig: sFrom0,
            dest: sTo0,
            brush: 'paleGrey',
            modifiers: {lineWidth: 10}
          }])
        }
      }
    },
    isevents () {
      return this.events
    },
    changeOrientation () {
      // window.alert(window.ground)
      window.orientationg = window.orientationg === 'white' ? 'black' : 'white'
      window.ground.set({
        orientation: window.orientationg,
        drawable: {
          enabled: true,
          visible: true
        }
      })
    },
    /* moveToHistory (index) {
      if (index < 0 || index > this.history.length - 1) {
        clearInterval(playEvent)
        this.played = false
        return
      }
      this.select = index
      var pgnReturn = ''
      var jugada = 0
      for (var i = 0; i <= index; i++) {
        if (i % 2 === 0) {
          jugada++
          pgnReturn += jugada + '. '
        }
        pgnReturn += this.history[i].san + ' '
      }
      if (!this.active) {
        this.$dispatch('move', {pgn: pgnReturn})
        return
      }
      if (this.humanvspc()) {
        this.$dispatch('move', {pgn: pgnReturn})
        return
      }
    },*/
    play () {
      this.played = !this.played
      if (this.played) {
        playEvent = setInterval(function () {
          this.moveToHistory(this.select + 1)
        }.bind(this), parseInt(this.velo) * 1000)
      } else {
        clearInterval(playEvent)
      }
    }
  },
  watch: {
    listaVocesSelected (val, oldVal) {
      // window.alert(JSON.stringify(val))
      Store.set('selectedVoice', val)
      this.myVoiceSelected = val
    },
    clubActual (val, oldVal) {
      this.clubs = val
      // window.alert(val)
    },
    airesponse (val, oldVal) {
      if (document.querySelector('#pgnComment' + ' textarea.comment')) {
        document.querySelector('#pgnComment' + ' textarea.comment').value = this.airesponse
        document.querySelector('#pgnComment' + ' textarea.comment').dispatchEvent(new window.Event('change'))
      }
      this.airesponse = val
      // window.alert(val)
    },
    velo (newVal, oldVal) {
      clearInterval(playEvent)
      this.played = false
      this.play()
    },
    eval (newVal, oldVal) {
    },
    enroqueK (newVal, oldVal) {
      this.setFenEnroque()
    },
    enroqueQ (newVal, oldVal) {
      this.setFenEnroque()
    },
    enroquek (newVal, oldVal) {
      this.setFenEnroque()
    },
    enroqueq (newVal, oldVal) {
      this.setFenEnroque()
    }
  },
  created () {
    if (this.$route && this.$route.name === 'game') {
      this.listaDeClubs('Clubs')
      if (this.board) {
        this.clubs = this.board.club
        this.nameLesson = this.board.lesson
        this.typeLesson = this.board.lessontype
        this.nameCategory = this.board.category
        this.nameAnalysis = this.board.name
        this.clubActual = this.board.club
      }
    }
    if (this.isParamOnly === false || true) {
      var voices = window.speechSynthesis.getVoices()
      if (voices.length > 0) {
        for (let i = 0; i < voices.length; i++) {
          this.listaVoces.push(voices[i].name)
          // window.alert(voices[i].name)
        }
        this.listaVocesSelected = Store.get('selectedVoice')
        if (this.listaVocesSelected === false || this.listaVocesSelected.length <= 0 && voices.length > 0 && voices[0] !== undefined) {
          this.listaVocesSelected = voices[0].name
        }
      }
    }
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  ul.history-board li:hover{
    background-color: #B9D4CB;
  }
  .historyMove {
    width: 50%;
    float: left
  }
  .item-select {
    background-color: #5f6b44;;
  }
  .item-select a {
        color: white;
    }
  .festivalimg {
    width: 80%;
    padding: 20px;
    display:block;
    margin:auto;
  }
  .logoimg {
    width: 60%;
    padding: 20px;
    display:block;
    margin:auto;
  }
  .loadbar
    {
         width:25px;
         height:200px;
         background-color:#000; /*var(--thumbBG);*/
         border:1px solid #000;
         position:relative; 
    }
    .bar
    {
        width:100%;
        display:block;        
        font-family:arial;
        font-size:12px; 
        background-color:#ffffff;
        color:#000;       
        position:absolute;
        bottom:0;        
    }
  #myProgress {
  width: 100%;
/*background-color: #ddd;*/
border: 1px;
box-sizing: content-box;
height: 20px;
position: relative;
/*margin: 0px 0 20px 0;*/
background: lightslategray;
border-radius: 25px;
padding: 2px;
box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
  }
.blancas{
  background: white;
  width: 10px;
}
.negras{
  background: black;
  width: 10px;
}
  #myBar {
  /* width: 50%;
height: 30px;*/
background-color: #5c005c;
display: block;
height: 100%;
width: 40px;
left: -20px;
border-top-right-radius: 20px;
border-bottom-right-radius: 20px;
border-top-left-radius: 20px;
border-bottom-left-radius: 20px;
/* background-color: rgb(43, 194, 83);*/
/* background-image: linear-gradient( center bottom, rgb(43, 194, 83) 37%, rgb(84, 240, 84) 69% );*/
box-shadow: inset 0 2px 9px rgba(255, 255, 255, 0.3), inset 0 -2px 6px rgba(0, 0, 0, 0.4);
position: relative;
overflow: hidden;
text-align: center;
color: white;

  }
  .spanAsIcon {
    color: white;
    vertical-align: middle;
    font-weight: bold;
  }
  .modal-content, .btn-primary, .card-header {
          background-color: #550055 !important;
          color: white !important;
      }
      .modal-header, .modal-title, .btn {
          background-color: #550055;
          color: white !important;
      }
      .btn-outline-danger {
          border-color: #550055;
          color: #550055;
      }
      .btn-outline-danger:hover {
          background-color: #550055;
          color: white;
      }
      .card {
          margin-top: 20px;
          box-shadow: 0 4px 8px rgba(85, 0, 85, 0.2);
      }
      .card-title {
          text-align: center;
      }
      .publisher {
          background-color: #f2e6f2 !important;
          border-top: 1px solid #550055 !important;
      }
      /* Adjusting modal positions */
      .modal-dialog {
          /*margin-top: 10%;*/
      }
      textarea {
        border: 1px solid #5c005c;
        border-radius: 5px;
        padding: 5px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .bot-container {
      margin-bottom: 20px;
    }
    .bot {
      width: 200px;
      height: auto;
      transition: transform 0.1s ease-in-out;
    }
    .text-container {
      text-align: center;
    }
    #botSpeech {
      font-size: 20px;
      margin-bottom: 10px;
    }
    .btn-floating {
      overflow: hidden;
    }
    .highlight
    {
      color: red;
      font-size: 34px;
    }
</style>
<template>
  <div>
    <div class="s12 m12 l12">
      <div id="overlay" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:5000; justify-content: center; align-items: center;">
        <div style="text-align: center; font-size: 24px; color: white;">Consultando a la IA...</div>
      </div>
      <!--<div v-if="user.chat" class="fixed-action-btn" style="bottom: 45px; right: 24px;">
          <a class="btn-floating btn-large purple darken-4">
            <i class="material-icons" @click="openChatSala()">voice_chat</i>
          </a>
      </div>-->
      
      <!-- <div class="fixed-action-btn horizontal">
      <a class="btn-floating btn-large purple darken-4">
        <i class="material-icons">menu</i>
      </a>
      <ul>
        <li v-if="isVideoSaving() && (user.role === 'Admin' || user.role === 'Teacher')"><a class="btn-floating blue darken-4" @click="openVideoSave()"><md-icon>stop_screen_share</md-icon></a></li>
        <li v-if="!isVideoSaving() && (user.role === 'Admin' || user.role === 'Teacher')"><a class="btn-floating blue darken-4" @click="openVideoSave()"><md-icon>screen_share</md-icon></a></li>
        <li v-if="user.chataudio"><a class="btn-floating purple darken-4" @click="openChatSala(false)"><md-icon >mic</md-icon></a></li>
        <li v-if="user.chat"><a class="btn-floating purple darken-4" @click="openChatSala()"><md-icon >linked_camera</md-icon></a></li>
        <li><a class="btn-floating orange darken-4" @click="changeStyle('board')"><md-icon>grid_on</md-icon></a></li>
        <li><a class="btn-floating green darken-4" @click="changeStyle('pieces')"><md-icon>grain</md-icon></a></li>
        !-- <li><a class="btn-floating blue darken-4"><i class="material-icons">attach_file</i></a></li>--
      </ul>-->
    </div>
    <md-modal id="modalCompartir" class="modal-fixed-footer">
        <h4 style="text-align: center">Compartir</h4>
        <div class="col s12 m12 l12">
          <div style="text-align: left">
            <blockquote class="chip">PGN</blockquote>
            <p>
            <span>{{ pgn }}</span>
            </p>
            <blockquote class="chip">FEN</blockquote>
            <p>
            <span>{{ fen }}</span>
            </p>
            <blockquote class="chip">IFRAME</blockquote>
            <p>
            <span>&lt;iframe src="{{ dirServer + '/#!/visor/0/0/only/' + board._id }}" allow="camera;microphone;" style="width: 1024px; height: 768px; transform: scale(0.5); transform-origin: 0 0; border: 0;"&gt;&lt;/iframe&gt;</span>
            </p>
            <p>
            <span><iframe :src="dirServer + '/#!/visor/0/0/only/' + board._id" allow="camera;microphone;" style="width: 1024px; height: 768px; transform: scale(0.5); transform-origin: 0 0; border: 0;"></iframe></span>
            </p>
          </div>
        </div>

        <span slot="footer" left>
          <md-button class="waves-effect waves-light purple darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'modalCompartir')">
            Cerrar
          </md-button>
        </span>
      </md-modal>
      <md-modal id="modalIA" class="modal-fixed-footer">
        <!-- <h4 style="text-align: center">{{board._id}}</h4>-->
        <select class="" style="display:inline;width:100%" v-model.lazy="listaVocesSelected">
          <option v-for="voz in listaVoces" :selected="isSelectedVoice(voz)" v-bind:key="isSelectedVoice(voz)">{{ voz }}</option>
        </select>
        
        <div class="col s12 m12 l12">
          <div class="col s2 m10 l2">
            <div class="bot-container">
              <!-- SVG para representar el robot -->
              <svg id="botSVG" class="bot" viewBox="0 0 300 500">
                <!-- Cabeza del robot con forma redondeada -->
                <rect x="50" y="50" width="100" height="100" rx="20" ry="20" fill="#c0c0c0" stroke="#5c005c" stroke-width="2"></rect>
                
                <!-- Antena en la parte superior de la cabeza -->
                <line x1="100" y1="35" x2="100" y2="50" stroke="#5c005c" stroke-width="3"></line>
                <circle cx="100" cy="30" r="5" fill="#5c005c" stroke="#000" stroke-width="2"></circle>
                
                <!-- Cejas del robot -->
                <rect id="leftEyebrow" x="65" y="65" width="20" height="5" fill="#5c005c"></rect>
                <rect id="rightEyebrow" x="115" y="65" width="20" height="5" fill="#5c005c"></rect>
                
                <!-- Ojos del robot con detalles -->
                <circle id="leftEye" cx="75" cy="85" r="8" fill="#fff" stroke="#000" stroke-width="2"></circle>
                <circle id="rightEye" cx="125" cy="85" r="8" fill="#fff" stroke="#000" stroke-width="2"></circle>
                <!-- Pupilas de los ojos -->
                <circle id="leftPupil" cx="75" cy="85" r="3" fill="#5c005c"></circle>
                <circle id="rightPupil" cx="125" cy="85" r="3" fill="#5c005c"></circle>
                
                <!-- Orejas del robot (laterales) -->
                <rect x="40" y="80" width="10" height="30" fill="#c0c0c0" stroke="#5c005c" stroke-width="2"></rect>
                <rect x="150" y="80" width="10" height="30" fill="#c0c0c0" stroke="#5c005c" stroke-width="2"></rect>
                
                <!-- Cuello simple -->
                <rect x="90" y="150" width="20" height="15" fill="#5c005c"></rect>

                <!-- Cuerpo del robot (más cuadrado y ancho) -->
                <rect x="60" y="165" width="80" height="100" fill="#d3d3d3" stroke="#5c005c" stroke-width="2"></rect>
                <!-- Panel decorativo en el cuerpo -->
                <rect x="80" y="185" width="40" height="50" fill="#9ec7e1" stroke="#5c005c" stroke-width="2"></rect>
                
                <!-- Brazos tipo palos y articulados -->
                <line id="leftUpperArm" x1="60" y1="180" x2="30" y2="210" stroke="#5c005c" stroke-width="3"></line>
                <line id="leftLowerArm" x1="30" y1="210" x2="15" y2="250" stroke="#5c005c" stroke-width="3"></line>
                <line id="rightUpperArm" x1="140" y1="180" x2="170" y2="210" stroke="#5c005c" stroke-width="3"></line>
                <line id="rightLowerArm" x1="170" y1="210" x2="185" y2="250" stroke="#5c005c" stroke-width="3"></line>
                <!-- Manos estilo pinza -->
                <circle cx="15" cy="250" r="8" fill="#5c005c" stroke="#000" stroke-width="2"></circle>
                <circle cx="185" cy="250" r="8" fill="#5c005c" stroke="#000" stroke-width="2"></circle>
                
                <!-- Piernas articuladas estilo caricatura -->
                <line x1="90" y1="265" x2="90" y2="320" stroke="#5c005c" stroke-width="3"></line>
                <line x1="110" y1="265" x2="110" y2="320" stroke="#5c005c" stroke-width="3"></line>
                <!-- Rodillas redondas -->
                <circle cx="90" cy="320" r="5" fill="#000"></circle>
                <circle cx="110" cy="320" r="5" fill="#000"></circle>
                <!-- Piernas inferiores -->
                <line x1="90" y1="320" x2="90" y2="360" stroke="#5c005c" stroke-width="3"></line>
                <line x1="110" y1="320" x2="110" y2="360" stroke="#5c005c" stroke-width="3"></line>
                <!-- Pies grandes estilo caricatura -->
                <rect x="80" y="360" width="20" height="10" fill="#5c005c"></rect>
                <rect x="100" y="360" width="20" height="10" fill="#5c005c"></rect>

                <!-- Bocetos de diferentes posiciones de la boca -->
                <!-- Boca neutral (cerrada) -->
                <path id="mouth1" d="M 80 120 Q 100 135 120 120" fill="none" stroke="#000" stroke-width="3"></path>
                <!-- Boca abierta pequeña -->
                <path id="mouth2" d="M 80 120 Q 100 145 120 120 Q 100 135 80 120 Z" fill="#000" style="opacity: 0;"></path>
                <!-- Boca con forma de O mejorada -->
                <ellipse id="mouth3" cx="100" cy="130" rx="15" ry="10" fill="#000" style="opacity: 0;"></ellipse>
                <ellipse id="tongue" cx="100" cy="135" rx="8" ry="4" fill="#5c005c" style="opacity: 0;"></ellipse>
                <!-- Boca muy abierta con detalles de lengua -->
                <path id="mouth4" d="M 70 120 Q 100 155 130 120 Q 100 135 70 120 Z" fill="#000" style="opacity: 0;"></path>
                <path id="tongue4" d="M 85 130 Q 100 150 115 130" fill="#5c005c" style="opacity: 0;"></path>
              </svg>
            </div>
          </div>
          <div class="col s10 m10 l7">
            <!-- <blockquote class="chip">PGN</blockquote>
            <p>
            <span>{{ pgn }}</span>
            </p>
            <blockquote class="chip">FEN</blockquote>
            <p>
            <span>{{ fen }}</span>
            </p>-->
            
            <div class="col s12 m12 l12">
              <div class="ps-container ps-theme-default ps-active-y" id="chat-content" style="overflow-y:auto !important; height: 50vh !important">
                <div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px">
                  <div class="ps-scrollbar-x" tabindex="0" style="left: 0px; width: 0px"></div>
                </div>
                <div class="ps-scrollbar-y-rail" style="top: 0px; height: 0px; right: 2px">
                  <div class="ps-scrollbar-y" tabindex="0" style="top: 0px; height: 2px"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="border col s12 m12 l9">
                <div style="text-align: left">
                  <textarea style="" id='aiquestion' @keydown.enter="preguntaAI()"></textarea>
                </div>
              </div>
              <div class="col s12 m12 l1">
                <div style="text-align: right">
                  <md-button class="btn-floating waves-effect waves-light purple darken-4" style="margin-top: 20px;" @click="preguntaAI()">
                    <span class="material-symbols-outlined">question_mark</span>
                  </md-button>
                </div>
              </div>
              <div class="col s12 m12 l1">
                <div style="text-align: right">
                  <md-button class="btn-floating waves-effect waves-light purple darken-4" style="margin-top: 20px;" @click="setTextToSpeach()">
                    <md-icon> {{ varTextToSpeach === true? 'volume_up' : 'volume_off' }} </md-icon>
                  </md-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col s12 m12 l3">
            <p></p>
            <board-visor-ia :game="board" id="ia-board" :classboard="classBoard" :pgn="pgn"></board-visor-ia>
          </div>
        </div>
        <!-- <p>
          <textarea style="font-family:'Söhne Mono', Monaco, 'Andale Mono', 'Ubuntu Mono', monospace !important; height:150px;" id='airesponse' v-model.lazy="airesponse"></textarea>
        </p>-->
        <!-- <blockquote class="chip">Pregunta</blockquote>-->
        
        <span slot="footer" left>
          <md-button class="waves-effect waves-light purple darken-4" style="margin-right: 10px;" @click="closeModalIA()">
            Cerrar
          </md-button>
          <!--<md-button class="waves-effect waves-light purple darken-4" style="margin-right: 10px;" @click="showInformationAI()">
            Asistente (IA)
          </md-button>-->
          <md-button class="waves-effect waves-light purple darken-3" style="margin-right: 10px;" @click="analizaAI()">
            Analisis profundo
          </md-button>
          
          <md-button id="btnStart" class="waves-effect waves-light purple darken-4" style="margin-right: 10px;" @click="startRecording()">
            <span id="counterDown" v-if="timeLeft > 0">{{timeLeft}}&nbsp;&nbsp;</span><i class="fa fa-microphone"></i>
          </md-button>
        </span>
      </md-modal>
    <md-modal id="analisys" class="modal-fixed-footer">
        <!-- <h4 style="text-align: center">Establecer posición</h4>-->
        <div class="col s12 m12 l12">
          <div style="text-align: center">
            <iframe id="iFrameAnalisys" width="600px" src="./static/analisys/analisys.html" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" frameborder="0" onload="this.style.height=(this.contentWindow.document.body.scrollHeight+40)+'px';"></iframe>
          </div>
        </div>
        <span slot="footer" left>
          <md-button class="waves-effect waves-light purple darken-4" style="margin-right: 10px;" @click="closeAnalisis()">
            Cerrar
          </md-button>
          <!-- <md-button class="green darken-4" style="margin-right: 10px;" @click="setFenInit()">
            Inicial !-- {{ $t("home.createPart.create") }}--
          </md-button>
          <md-button class="green darken-4" style="margin-right: 10px;" @click="setFenClear()">
            Borrar !-- {{ $t("home.createPart.create") }}--
          </md-button>
          <md-button class="col s1 m1 l1 left" style="margin-right: 10px;" @click="enroqueK = !enroqueK">K: {{enroqueK}}</md-button>
          <md-button class="col s1 m1 l1 left" style="margin-right: 10px;" @click="enroqueQ = !enroqueQ">Q: {{enroqueQ}}</md-button>
          <md-button class="col s1 m1 l1 left purple darken-4" style="margin-right: 10px;" @click="enroquek = !enroquek">k: {{enroquek}}</md-button>
          <md-button class="col s1 m1 l1 left purple darken-4" style="margin-right: 10px;" @click="enroqueq = !enroqueq">q: {{enroqueq}}</md-button>-->
        </span>
      </md-modal>
      <!-- <span v-bind:key="move" v-for="move in history" @click="moveToHistory($index)" class="" style="padding: 0 0 !important" v-bind:class="[select === $index ? 'item-select' : '']"> 
            <label v-if="$index % 2 ===0">{{ ($index/2)+1 }}. </label>
            <label v-if="$index % 2 !==0"> ... </label>
            <b style="cursor:pointer;">{{ move.san }}</b>
        </span>-->
      <md-modal id="setFen" class="modal-fixed-footer">
        <!-- <h4 style="text-align: center">Establecer posición</h4>-->
        <div class="col s12 m12 l12">
          <div style="text-align: center">
            <!--<iframe id="iFramePosition" width="400" height="500" src="./static/libs/fen/fen.html" frameborder="0"></iframe>-->
            <iframe id="iFramePosition" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" width="100%" src="./static/libs/cm-fen-editor-main/index.html" frameborder="0"></iframe>
          </div>
        </div>
        <span slot="footer" left>
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'setFen')">
              {{ $t("about.close") }}  <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
          <md-button class="waves-effect waves-light purple darken-4" style="margin-right: 10px;" @click="setFenPosition()">
            {{ $t("game.accept") }} <!-- {{ $t("home.createPart.create") }}-->
          </md-button>
          <!-- <md-button class="green darken-4" style="margin-right: 10px;" @click="setFenInit()">
            Inicial !-- {{ $t("home.createPart.create") }}--
          </md-button>
          <md-button class="green darken-4" style="margin-right: 10px;" @click="setFenClear()">
            Borrar !-- {{ $t("home.createPart.create") }}--
          </md-button>
          <md-button class="col s1 m1 l1 left" style="margin-right: 10px;" @click="enroqueK = !enroqueK">K: {{enroqueK}}</md-button>
          <md-button class="col s1 m1 l1 left" style="margin-right: 10px;" @click="enroqueQ = !enroqueQ">Q: {{enroqueQ}}</md-button>
          <md-button class="col s1 m1 l1 left purple darken-4" style="margin-right: 10px;" @click="enroquek = !enroquek">k: {{enroquek}}</md-button>
          <md-button class="col s1 m1 l1 left purple darken-4" style="margin-right: 10px;" @click="enroqueq = !enroqueq">q: {{enroqueq}}</md-button>-->
        </span>
      </md-modal>
      <md-modal id="setResource" class="modal-fixed-footer">
        <!-- <h4 style="text-align: center">Establecer posición</h4>-->
        <div class="col s12 m12 l12">
          <div class="row">
            <div class="section">
              <md-input name="search" :value.sync="strNameResource">
                Nombre
              </md-input>
            </div>
            <legend>Opciones:</legend>
            <fieldset>
              <md-input name="search" :value.sync="urlLinkUpload">
                URL completa (https://...)
              </md-input>
              <md-button :class="urlLinkUpload.length > 0 && strNameResource.length > 0  ? 'purple darken-4' : 'disabled purple darken-4'" style="margin-right: 10px;" @click="setLinkUpload()">
                Añadir URL
              </md-button>
              <p>Subir un archivo (PGN, JPG, PGN, PDF, ...)</p>
              <div style="text-align: center">
                <label style="position: relative;float: right;" v-if="!allFilesUploaded">{{
                                      fileProgress }}</label>
                <upload-files-lesson
                        :value.sync="filesUploadHistory"
                        name="filesLesson"
                        multiple
                        :action="dirActionUpload"
                        maxsize="110MB"
                        pathpermit="|jpeg|mp4|zip|rar|png|pgn|pdf|doc|docx|ppt|pptx|webm|txt"
                >
                    <a  :class="strNameResource.length > 0  ? 'btn waves-effect waves-light col s3 m3 l3 purple darken-4' : 'disabled btn waves-effect waves-light col s3 m3 l3 purple darken-4'"
                        data-tooltip="Compartir archivo">
                        {{ $t("home.upload") }}
                    </a>
                </upload-files-lesson>
              <!--<iframe id="iFramePosition" width="400" height="500" src="./static/libs/fen/fen.html" frameborder="0"></iframe>-->
              </div>
            </fieldset>
          </div>
        </div>
        <span slot="footer">
            <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'setResource')">
              {{ $t("about.close") }}  <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
            </md-button>
          </span>
      </md-modal>
      <md-modal id="setData" class="modal-fixed-footer">
        <!-- <h4 style="text-align: center">Establecer posición</h4>-->
        <!-- <div class="col s12 m12 l8">
          <div style="text-align: center">
            <iframe id="iFramePosition" width="400" height="500" src="./static/libs/fen/fen.html" frameborder="0"></iframe>
          </div>
        </div>-->
        <div class="col s12 m12 l12">
          <form id="insertValues" style="text-align: left">
            <div class="col s12 m12 l12">
              <!--<md-checkbox name="fenSetPossible" :value.sync="fenSetPossible">FEN</md-checkbox>-->
              <md-input name="eventoFen" :value.sync="fenEvento" placeholder='Festival de Salamanca'>Evento</md-input>
              <md-input name="lugarFen" :value.sync="fenLugar" placeholder='Salamanca'>Lugar</md-input>
              <md-input name="fechaFen" :value.sync="fenFecha" placeholder='13.10.2020'>Fecha</md-input>
              <md-input name="rondaFen" :value.sync="fenRonda" placeholder='1'>Ronda</md-input>
              <md-input name="resultadoFen" :value.sync="fenResultado" placeholder='1/2-1/2'>Resultado</md-input>
              <md-input name="blancasFen" :value.sync="fenBlancas" placeholder='Iturrizaga'>Blancas</md-input>
              <md-input name="negrasFen" :value.sync="fenNegras" placeholder='Topalov'>Negras</md-input>
            </div>
          </form>
          <!-- <fieldset>
            <legend>Datos de la lección</legend>
            <md-input name="nameCategory" :value.sync="nameCategory">
                Nombre de la categoría
            </md-input>
            <md-input name="nameLesson" :value.sync="nameLesson">
                Nombre de la lección
            </md-input>
            <div class="col s12 m4 l4 input-field">
                      <select multiple class="emojiclass" v-on:change="handleSelectChange" style="display:inline;width:100%;height:auto;">
                          <option v-for="club in listaclubs" :selected="isSelected(club.name)" v-bind:key="isSelected(club.name)">{{ club.name }}</option>
                          !--<img style="width: 100%;" v-bind:src="imageUrl(club.image)" alt="" @error="imageUrlAlt">--
                      </select>
                  </div>
          </fieldset>-->
        </div>
        <span slot="footer">
          <!--<md-switch class="left large" :value.sync="chkLesson">
                <span slot="on"></span>
                <span slot="off"></span>
            </md-switch>-->
            <md-button class="waves-effect waves-light purple darken-4" style="margin-right: 10px;"
                    @click="setDataPosition()">
            Aceptar <!--{{ $t("home.createPart.create") }}-->
          </md-button>
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'setData')">
              {{ $t("about.close") }}  <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
        </span>
      </md-modal>
      <md-modal id="setFields" class="modal-fixed-footer">
        <h4 style="text-align: center">Modificar campos de la partida</h4>
        <!-- <div class="col s12 m12 l8">
          <div style="text-align: center">
            <iframe id="iFramePosition" width="400" height="500" src="./static/libs/fen/fen.html" frameborder="0"></iframe>
          </div>
        </div>-->
          <div class="col s12 m12 l12">
          <form id="insertValues" style="text-align: left">
            <md-input name="nameAnalysis" :value.sync="nameAnalysis">
                Nombre del aula
          </md-input> 
          <fieldset>
            <legend>Datos de la lección</legend>
            <md-input name="typeLesson" :value.sync="typeLesson">
                Tipo de la lección
            </md-input>
            <md-input name="nameCategory" :value.sync="nameCategory">
                Nombre de la categoría
            </md-input>
            <md-input name="nameLesson" :value.sync="nameLesson">
                Nombre de la lección
            </md-input>
            <div class="col s12 m12 l12 input-field">
                      <select multiple class="" v-on:change="handleSelectChange" style="display:inline;width:100%;height:200px;">
                          <option v-for="club in listaclubs" :selected="isSelected(club.name)" v-bind:key="isSelected(club.name)">{{ club.name }}</option>
                          <!--<img style="width: 100%;" v-bind:src="imageUrl(club.image)" alt="" @error="imageUrlAlt">-->
                      </select>
                  </div>
          </fieldset>
        </form>
        </div>
        <span slot="footer">
          <md-button class="waves-effect waves-light purple darken-4" style="margin-right: 10px;"
                    @click="setDataFields()">
            Aceptar <!--{{ $t("home.createPart.create") }}-->
          </md-button>
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'setFields')">
              {{ $t("about.close") }}  <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
        </span>
      </md-modal>
    
      <div class="col s12 m12 l12">
      <!--  <md-button data-tooltip="Atras" class="btn-floating btn-flat purple darken-4" @click="moveToHistory(select - 1)">
          <md-icon>arrow_left</md-icon>
        </md-button>

        <md-button data-tooltip="Reproducir" class="btn-floating btn-flat purple darken-4" @click="play()">
          <md-icon>{{ played ? 'pause' : 'play_arrow' }}</md-icon>
        </md-button>
        <md-button data-tooltip="Adelante" class="btn-floating btn-flat purple darken-4" @click="moveToHistory(select + 1)">
          <md-icon>arrow_right</md-icon>
        </md-button>
        <md-button data-tooltip="Cambiar orientiación"
                      class="btn-floating btn-flat purple darken-4" @click="changeOrientation">
                <md-icon>screen_rotation</md-icon>
              </md-button>
        !--<label class="col s1 m1 l1">{{velo}}</label>
        <input v-model="velo" type=range min=0 max=5 step=1 class="col s4 m4 l4" >-->
        <md-button data-tooltip="Analizar" v-if="!active && (user.role === 'Admin' || user.role === 'Teacher' || user.analyse) || ($route && $route.name === 'visor')" class="btn-floating purple darken-4" @click="openModal();">
          <md-icon>computer</md-icon>
        </md-button>
        <md-button data-tooltip="Analizar partida" v-if="!active && (user.role === 'Admin' || user.role === 'Teacher' || user.analyse)" class="btn-floating purple darken-4" @click="openModalGraph();">
          <md-icon>show_chart</md-icon>
        </md-button>
        <md-button data-tooltip="Analizar posición" v-if="!active && (user.role === 'Admin' || user.role === 'Teacher' || user.analyse)" class="btn-floating purple darken-4" @click="openModalGraphFEN();">
          <md-icon>explore</md-icon>
        </md-button>
        <md-button data-tooltip="Descargar" v-if="isParamOnly === false && (!active && (user.download || ($route && $route.name === 'visor')))" class="btn-floating btn-flat purple darken-4" @click="downloadPGN();">
          <md-icon>file_download</md-icon>
        </md-button>
        
        <!--<md-button v-if="!active && user.chat" v-if="this.board._id!==undefined && user.chat" class="btn-floating btn-flat purple darken-4" @click="openChat();">
          <md-icon>voice_chat</md-icon>
        </md-button>
        <md-button v-if="!active && user.chataudio" v-if="this.board._id!==undefined && user.chataudio" class="btn-floating btn-flat purple darken-4" @click="openChat(false);">
          <md-icon>chat_bubble_outline</md-icon>
        </md-button>-->
        <md-button data-tooltip="Crear posición" v-if="humanvspc() && isOwner() && ($route && $route.name === 'game')" class="btn-floating btn-flat purple darken-4" @click="setFen();">
          <md-icon>build</md-icon>
        </md-button>
        <md-button data-tooltip="Editar datos de la partida" v-if="humanvspc() && isOwner() && ($route && $route.name === 'game')" class="btn-floating btn-flat purple darken-4" @click="setData();">
          <md-icon>mode_edit</md-icon>
        </md-button>
        <md-button data-tooltip="Editar campos" v-if="humanvspc() && isOwner() && ($route && $route.name === 'game') && (user.role === 'Admin' || user.role === 'Teacher')" class="btn-floating btn-flat purple darken-4" @click="setFields()">
          <md-icon>text_fields</md-icon>
        </md-button>
        <!-- <md-btn class="btn-floating btn-flat purple darken-4" 
                @click="changeStyle('pieces')">
          <md-icon>grain</md-icon>
        </md-btn>
        <md-button class="btn-floating btn-flat purple darken-4" 
                @click="changeStyle('board')">
          <md-icon>grid_on</md-icon>
          !-- <img class="" style="vertical-align: middle; text-align: center; width: 70%" src="../../../static/images/chess-board.png" />--
        </md-button>-->
        <md-button data-tooltip="Cambiar permisos" v-if="($route && $route.name === 'game') && humanvspc() && isOwner() && (user.role === 'Admin' || user.role === 'Teacher')" class="btn-floating btn-flat purple darken-4" @click="sendPermisionToSend()">
          <md-icon>send</md-icon>
        </md-button>
        <md-button data-tooltip="Enviar línea" v-if="(sendtoteacher) && humanvspc() && !isOwner() && (user.role === 'Admin' || user.role === 'Teacher')" class="btn-floating btn-flat purple darken-4" @click="sendPGNtoTeacher()">
          <md-icon>send</md-icon>
        </md-button>
        <!-- <md-button v-if="!active && !humanvspc() && (user.role === 'Admin' || user.role === 'Teacher' || user.cast)" 
          v-if="!humanvspc() && (user.role === 'Admin' || user.role === 'Teacher' || user.cast)" class="btn-floating btn-flat purple darken-4" @click="analizaPGN()">
          <md-icon>cast</md-icon>
        </md-button>-->
        
        <!-- <md-button v-if="!active && user.analyse" v-if = "user.analyse" class="btn-floating purple darken-4 disabled">
          <span>{{ eval }}</span>
        </md-button>-->
        <md-button v-if="humanvspc() && isOwner() && ($route && $route.name === 'game')" data-tooltip="Añadir recurso a la posición" class="btn-floating btn-flat purple darken-4" @click="setResource();">
          <md-icon>attach_file</md-icon>
        </md-button>
        <md-button data-tooltip="Compartir datos de la partida" class="btn-floating btn-flat purple darken-4" v-if="isParamOnly === false && (fen.length && !active)" @click="showShare();">
          <md-icon>share</md-icon>
        </md-button>
        <md-button data-tooltip="Inteligencia Artificial" v-if="isParamOnly || (fen.length && pgn.length && !active)" class="btn-floating btn-flat purple darken-3" @click="showIA();">
          <span class="spanAsIcon">IA</span>
        </md-button>
        <md-button data-tooltip="Insertar comentarios en la posición (IA)" class="btn-floating btn-flat purple darken-3"  v-if="isParamOnly || (fen.length && pgn.length && !active)" @click="insertComments();">
          <i class="fa fa-comment" aria-hidden="true"></i>
        </md-button>
        <md-button data-tooltip="Insertar comentarios en la partida (IA)" v-if="(user.role === 'Admin' || user.role === 'Teacher') && isevents() === false && (isParamOnly || (fen.length && pgn.length && !active))" class="btn-floating btn-flat purple darken-3"  @click="commentAI();">
          <i class="fa fa-comments" aria-hidden="true"></i>
        </md-button>
        <div style="display:none;" ><b class="flat-text-header">Voz: </b><input id='myVoiceSelected' v-model.lazy="myVoiceSelected" /></div>
        <md-button data-tooltip="Actualizar datos de la partida" class="btn-floating btn-flat purple darken-4" v-if="(user.role === 'Admin' || user.role === 'Teacher') && humanvspc() && isOwner() && ($route && $route.name === 'game')" @click="updateData();">
          <md-icon>update</md-icon>
        </md-button>
      </div>
      <!-- <h6 id='eval' class="flat-text-header hello" style="text-align: center"></h6>-->
      <!--<div v-if="!active">-->
      <div>
      <!-- Análisis -->
        <div id="analisisModal" style="display:none;z-index:-100;">
          <div id="fen" style="display:none">{{ fen }}</div>
          <div id="container" style="z-index:-100;">
            <div id="searchWrapper" style="display:none">
              <form id="simpleSearch">
                <input name="search" placeholder="Enter FEN, PGN or command" id="searchInput" type="search" value="{{ pgn }}">
                <div id="buttonGo" data-tooltip="Load FEN, PGN or command" style="display:none"></div>
              </form>
            </div>
            <div id="buttonBack"  style="display:none;" class="off" data-tooltip="Go back"></div>
            <div id="buttonForward"  style="display:none;" class="off" data-tooltip="Go forward"></div>
            <div id="buttonRefresh"  style="display:none;" class="off" data-tooltip="Refresh"></div>
            <div id="buttonRevert" style="display:none;" class="off" data-tooltip="Revert changes"></div>
            <div id="buttonWindow" style="display:none;" class="off" data-tooltip="Open in new window"></div>
            <div id="buttonEdit" style="display:none;" class="on" data-tooltip="Edit mode"></div>
            <div id="buttonMenu"  style="display:none;" class="on" data-tooltip="Menu"></div>
            <div id="buttonInfo" style="display:none;" class="on" data-tooltip="Info"></div>
            <div id="boardWrapper" style="display:none;">
                <table id="cbTable"><tbody>
                    <tr><td></td><td>a</td><td>b</td><td>c</td><td>d</td><td>e</td><td>f</td><td>g</td><td>h</td><td><div id="buttonStm" class="white" data-tooltip="Change side to move"><div></div></div></td></tr>
                    <tr><td>8</td><td colspan="8" rowspan="8" class="cbCell"><div id="chessboard1" class="cb"></div></td><td>8</td></tr>
                    <tr><td>7</td><td>7</td></tr><tr><td>6</td><td>6</td></tr><tr><td>5</td><td>5</td></tr><tr><td>4</td><td>4</td></tr>
                    <tr><td>3</td><td>3</td></tr><tr><td>2</td><td>2</td></tr><tr><td>1</td><td>1</td></tr>
                    <tr><td></td><td>a</td><td>b</td><td>c</td><td>d</td><td>e</td><td>f</td><td>g</td><td>h</td><td><div id="buttonFlip" data-tooltip="Flip board"></div></td></tr>
                </tbody></table>
            </div>
            <div id="moves" ></div>
            <div id="infoWrapper" style="display:none;"><div>
            <div id="infoBtn1" class="infoIcon selected" style="display:none;right: 22px;bottom:0px;"></div>
            <div id="infoBtn2" class="infoIcon" style="display:none;right: 0px;bottom:0px;"></div>
            <div id="infoContent" style="display:none;"></div>
          </div>
        </div>
        <div id="graphWrapper" style="display:none"><canvas id="graph">Your browser does not support the HTML5 canvas tag.</canvas></div>
        <div id="menu" style="display:none"></div>
        <div id="status" style="display:none"></div>
      </div>
      <!--<div class="box" style="height:125px;min-height:79px;width:100%;top:10px" id="wLczero">
            <div id="lczeroInfo" class="boxTop">Red Neuronal LcZero</div>
            <div id="lczeroHeader"><div class="san">Movimiento</div><div class="policy">Norma</div><div class="eval">Valor</div></div>
            <div id="lczero" class="boxMid scrollpurple"></div>
            <div id="lczeroFooter" class="footer" style="display:none">powered by <a href="https://github.com/frpays/lc0-js/">Lc0-js</a>, <a href="https://github.com/LeelaChessZero/">LeelaChessZero</a> and <a href="https://js.tensorflow.org/">tensorflowjs</a></div>
          </div>-->
      
          <div class="col s12 m12 l12" style="display: inline-flex;margin-top: 20px;">
            <div class="negras" style="background: black;padding: 10px;flex: auto;margin-right: 5px;"></div>
              <div id="myProgress" class="">
                  <div id="myBar">{{ eval }}</div>
              </div>
            <div class="blancas" style="background: white;padding: 10px;flex: auto;margin-left: 5px;"></div>
        <!--  <div class="col s12 m12 l12 loadbar" style="display: inline-flex;margin-top: 20px;">
        <strong id="myBar2" class="bar">{{ eval }}</strong>
      </div>-->
      </div>
      
      </div>
      </div>
              
      <!-- <a v-if="$route.name === 'events'" href = "https://www.salamancachessfestival.com"><img class="festivalimg" src="../../../static/images/festival2021/IIIFestival_Ajedrez-1024x576.jpg"/>
      <a v-if="$route.name === 'events'" href = "https://salamancaajedrez.com"><img class="logoimg" src="../../../static/images/festival2021/logo.png"/>-->
      
  <!-- // Análisis -->
  </div>
</template>


// WEBPACK FOOTER //
// boardHistory.vue?02acf020